var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _ellipse2, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 240,
    viewBox: "0 0 75 88",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.451 -202.22)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.181,
    transform: "matrix(.31427 0 0 .31447 5.83 198.852)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196.65,
    height: 279.2,
    x: 8.656,
    y: 10.87,
    fill: "#000",
    fillOpacity: 1,
    stroke: "gray",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.636,
    rx: 7.52,
    ry: 7.518
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.845,
    cy: -168.833,
    fill: "none",
    fillOpacity: 1,
    stroke: "#f2f2f2",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    display: "inline",
    opacity: 1,
    rx: 20.83,
    ry: 20.84,
    transform: "rotate(90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M148.064 36.138s2.273 4.835 3.957 6.874c2.57 3.115 5.567 6.093 9.166 7.928 2.366 1.207 5.103 1.746 7.758 1.817 2.945.078 5.879-.713 8.702-1.557 2.266-.677 4.43-1.69 6.525-2.788 1.34-.702 3.84-2.42 3.84-2.42s-1.447 2.995-2.464 4.294c-1.43 1.825-3.1 3.52-5.03 4.807a21.945 21.945 0 01-6.893 3.024c-2.2.54-4.53.704-6.783.463-2.546-.272-5.088-.99-7.38-2.13-2.173-1.08-4.259-2.509-5.83-4.357-2.424-2.848-4.185-6.345-5.19-9.947-.538-1.933-.378-6.008-.378-6.008z",
    display: "inline"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M179.44 19.914c-3.301-1.593-6.943-2.788-10.607-2.9-2.845-.086-5.696.744-8.359 1.75-1.344.507-3.748 2.127-3.748 2.127l-2.12 3.044 2.61 1.647 2.405-1.212 2.698-1.999 1.327 1.68 1.969-.39-1.327.817-.316 2.442 2.183-2.244 2.217 1.228 1.904-1.858.925.642-3.54 3.52 3.018.307-7.11 4.475 2.143 1.076 6.284 1.428 1.09-1.433-3.52-2.318 2.801-.95-.083-1.168.785-1.193-.02 1.179 1.337 1.248 2.441-2.495.42 1.928 1.193-.195 2.673 1.991 1.57-.13 1.751-1.852-1.8.92-1.885.243-2.117-2.16.042-1.878-1.475-1.536-.817-1.891 2.174.22 1.474 3.14 2.357 1.042-1.223-2.774-1.25-2.214 2.843-.871s-2.083-1.836-3.318-2.433z",
    display: "inline"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M151.15 28.004l.735.545.45-.031.762-.608.44-.84 1.23.26.72.725.117.788.231.648 1.205-.603.74-.636.516.069.999.053.237 1.8-.546 1.257-1.01.555.155 1.903.525 1.039-1.482-1.361-.406-1.356.41-1.549.507-.407-.809.013-1.167.601-.275 1.072.1.884-.59-1.685-.064-1.313-.405.031-.43.448-.357 1.743.562 1.45.825 1.555.834 1.08 1.213.915.975.589-.23.88-1.215-.842-1.085-1.13-1.549-1.96-.951-1.964-.423-1.15-.428-1.159-1.036-.793-.49-.593z",
    display: "inline"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M186.444 27.68l-.815-1.358-.858.346-.232 1.778.676.867s.393.651.431.785c.038.134.165.738.138 1.113-.027.375-.293 1.868-.293 1.868l.052 1.397.844-1.33-.346 2.26.804-.967.15.806.872.066.96-.348.384-.868-.427-1.489-.322-.803-.724-.342s-.527-.313-.584-.427c-.058-.115-.484-1.695-.484-1.695l.468-.92-.294-.695z",
    display: "inline"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M185.193 38.6l-.019 1.323-1.274.704-1.541.448-1.288.906-.31 1.077.896-.356.436-.646.57-.308.998.2 1.535-.015 1.471-.287.774-1.207-.173-1.079-.621-.145-.132-.444-.607-.022z",
    display: "inline"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M171.078 46.844l-2.106 2.674-.521 1.38-.952 1.467 1.566-.713.349-1.129 1.837-1.757z",
    display: "inline"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M161.446 48.687l.72 1.388-.72.888.573-.258.696.248-.34-.276.546-1.235-.378-.563z",
    display: "inline"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M176.628 49.203l.587.73-.084.633 1.275-.202.946.154-.375-.672.429-.855-1.02.449-.597-.346z",
    display: "inline"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M153.472 43.432l.705 1.413 1.217-.487 1.135.392-1.127-1.202-.444-1.514-1.216.176.572 1.317-1.24-1.081-1.153-.331z",
    display: "inline"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.351,
    height: 19.277,
    x: 8.656,
    y: 270.793,
    fill: "#ccc",
    fillOpacity: 1,
    stroke: "gray",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.636,
    rx: 8.327,
    ry: 7.182
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M175.765 290.036l-1.589-7.113-3.317-8.615-5.628-9.816-6.272-10.005-1.647-3.588-.439-3.465.38-2.791 3.825-4.072 1.136-4.501-1.268-5.386-1.106-4.776-1.828-4.873-2.052-3.466-81.52-108.306 1.008-3.75-2.241-1.871-23.233-33.635-7.218-6.98-6.05-8.306-8.015-6.25-5.547-7.621-6.45-5.606-4.61-7.213-3.581-2.586.226 258.134 11.24 6.3z",
    display: "inline"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.384,
    d: "M110.601 269.923l.593.007.72.47-.75.271-.147.548.347.23.06.717.014.874.1.494.61.92.222.542-.037.327.211.13.234.508.583 1.115.261.493.217.437.237.316.257.23.259.569-.071.381-.974.224-1.024.058-1.031-.652-.48-.94-1.484-.77-.464-.845-.33-.65-1.334-1.24-1.06-1.228.641-.54.766-.396.134-.885.605-.207.826-.38.525-.554z",
    display: "inline"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.384,
    d: "M110.347 269.92c.087-.009.174-.014.259-.034a.482.482 0 00.225-.114.324.324 0 00.09-.12c.012-.05.048-.08.086-.11.09-.063.182-.123.267-.192.085-.06.164-.137.264-.174.073 0 .117.076.154.13.044.057.08.12.133.169.149.07.245.199.336.33.02.033.04.065.058.098.037.066.075.132.11.2.051.102.08.215.114.325.04.108.088.213.128.321.03.104.069.203.113.301l.04.095c.056.129.112.257.186.376.006.01-.01-.02-.014-.03.049.087.108.168.173.244.066.079.113.17.164.259.01.017.033.071.03.052-.003-.021-.02-.037-.03-.055.046.075.093.15.177.187.06.015.116.04.171.068.065.028.128.06.193.089.07.028.146.03.22.033.094 0 .187-.02.28-.036.075-.015.119-.008.171.05.077.086.094.14.105.236-.016.001.029.077.018.057-.121-.218.006-.007.024.057a.338.338 0 010 .17c-.013.069-.03.137-.046.205l-.029.172a.997.997 0 00-.032.173c0 .05-.01.1-.016.149-.008.058-.01.117-.012.176-.017-.01.024.07.014.054-.013-.02-.057-.067-.034-.062.025.006.027.043.04.064l.088.134a.937.937 0 00.29.262.427.427 0 00.235.002.725.725 0 01.158-.028c.075-.01.13.037.185.08.05.04.1.079.146.122.064.063.11.142.163.216.09.114.182.227.232.365.038.117.033.243.044.364.003.087.022.172.036.257.017.078.06.146.095.217.035.087.076.172.112.26.044.116.073.238.089.361a.89.89 0 01-.037.369 1.29 1.29 0 00-.083.298 5.318 5.318 0 01-.025.293 1.12 1.12 0 01-.033.202.975.975 0 01-.076.175c-.018.051-.052.094-.077.142a.207.207 0 01-.064.093c-.055.063-.125.108-.195.153a.57.57 0 00-.194.157.255.255 0 00-.046.133 1.137 1.137 0 00-.001.117v.268c-.003.034-.007.069-.035.09-.037.02-.08.012-.12.013a.712.712 0 00-.122.024.387.387 0 01-.11.016 2.74 2.74 0 01-.172.02c-.062 0-.109.038-.148.081-.056.074-.098.155-.159.225-.036.048-.092.06-.143.084l-.089.034-.06-.11c.03-.01.059-.021.087-.033.049-.025.104-.034.14-.08.06-.07.102-.153.158-.226.041-.044.092-.086.156-.086.057-.004.115-.011.172-.02a.383.383 0 00.108-.015.867.867 0 01.125-.026c.037 0 .077.006.112-.009.024-.02.024-.055.026-.084a41.397 41.397 0 000-.268c0-.04-.001-.078.003-.118a.276.276 0 01.052-.136.597.597 0 01.198-.158.878.878 0 00.193-.153.227.227 0 00.06-.091c.026-.047.059-.091.077-.142a.898.898 0 00.074-.173c.017-.066.027-.133.032-.2.012-.098.018-.195.026-.293.015-.103.047-.202.084-.3a.873.873 0 00.033-.365 1.585 1.585 0 00-.092-.36c-.037-.087-.077-.173-.113-.26-.036-.07-.078-.14-.092-.219-.015-.085-.032-.17-.035-.256-.011-.121-.006-.247-.047-.363-.006-.015-.03-.055-.018-.044.019.017.029.04.04.064.006.015-.02-.028-.03-.041-.025-.034-.041-.053-.067-.086l-.035-.045c-.052-.073-.098-.15-.16-.216-.046-.044-.096-.082-.146-.122-.051-.042-.103-.093-.175-.084a.706.706 0 00-.157.027.471.471 0 01-.243 0 .954.954 0 01-.296-.26c-.042-.065-.089-.13-.128-.197-.045-.075-.095-.127-.098-.209.002-.06.004-.118.012-.177.008-.05.014-.099.016-.149.007-.058.018-.116.033-.173.01-.057.019-.115.03-.172a5.13 5.13 0 00.046-.205.332.332 0 00-.005-.166c-.003-.007-.013-.03-.008-.023.019.029.07.12.053.09-.038-.07-.08-.11-.086-.183-.002-.02-.003-.04-.009-.06-.002-.007-.012-.027-.008-.02.013.019.08.132.034.06-.048-.059-.083-.07-.16-.055-.093.015-.187.036-.282.037-.075-.002-.152-.003-.223-.03-.066-.028-.129-.062-.195-.09a.698.698 0 00-.17-.068c-.087-.033-.137-.107-.185-.185l-.092-.156c-.01-.018-.041-.07-.03-.053.094.139-.022-.023-.04-.047a1.491 1.491 0 01-.175-.245 4.11 4.11 0 01-.332-.65 2.464 2.464 0 01-.113-.304c-.041-.107-.09-.212-.127-.32-.024-.079-.046-.158-.076-.233-.012-.03-.029-.06-.04-.09 0-.004.013.011.01.007-.016-.033-.037-.065-.056-.097-.089-.13-.182-.264-.332-.329-.056-.046-.09-.111-.137-.166-.034-.052-.073-.126-.138-.138-.1.034-.178.11-.261.17-.085.07-.176.13-.266.193-.037.03-.069.06-.08.108a.37.37 0 01-.096.122.509.509 0 01-.23.117c-.086.02-.174.025-.262.037l-.057-.112z",
    display: "inline"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.384,
    d: "M8.77 117.199v.625l1.174-.498.925.545.724.414.607-.278.916.285.795.598h.272l-.377.764-.456.158-.351-.528-.625.98-.463.556-.221 1.19s.046.66.03.548c-.016-.112 1.055.743 1.055.743l.362-.105.047.42.572.163-.081.318.218.107.416-.336.195.276.394.018.11.732.671-.448.087.425.29.247.435.093.11.376.774.855.134.303-.164.29-.183.404-1.486-.234-1.19.271-.735.003-2.08.39-.637-.077-.914.37-.547-.171-.803.408z",
    display: "inline"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.384,
    d: "M8.777 113.52c.078.068.15.141.22.216.083.09.162.182.228.284a.658.658 0 01.125.35c-.003.09.014.179.028.268.014.068.023.138.05.201.016.035.036.068.053.102-.01-.017-.045-.058-.028-.05.02.01.023.036.035.053.012.018.024.036.037.052.048.06.105.11.165.159.114.09.242.157.37.225.072.036.146.07.212.118l.03.023c.126.074-.037-.045.15.085.133.091.253.2.375.304.185.16.382.306.578.454.09.06.173.132.273.174.062.026.084.03.149.046l.078.012c.085.011.075.006.16.023.07.015.14.039.208.062.08.024.152.062.214.117.097.11.108.237.133.371a.583.583 0 00.072.177c.008.015.032.06.025.044l-.031-.056c.053.077.107.155.175.22l.149.13c.114.082.217.205.348.261.022.01.045.014.067.021.13.026.262.025.393.015.096-.008.19-.027.287-.026.076.009.151.026.227.036.1.017.11.078.159.168.01.025.01.053.018.078.009.027.084.154-.044-.076.023.001.048-.035.063-.05.046-.047.113-.065.171-.093.079-.05.061-.085.167-.08.095.015.18.06.258.111.035.028.07.053.1.086.026.027.038.051.068.075.018.014.037.025.056.037.164.08.352.056.526.091.03.006.06.017.09.025a.933.933 0 01.325.226c.05.056.093.12.135.183.07.111.15.216.234.317.058.07.129.129.196.191.09.1.189.19.3.266a.323.323 0 01.121.238c.007.051-.002.102-.009.153-.005.042.003.084.006.126.007.048 0 .096-.005.144-.002.055-.01.108-.02.162-.018.082.005.161.023.241.037.142.055.288.097.429.04.113.083.226.124.339.032.06.061.121.095.18-.014-.026-.057-.103-.044-.077.022.044.048.086.07.13.024.045.04.097.057.145-.065-.095.112.204.055.108-.08-.138-.01-.028.011 0 .051.07.095.141.138.216.01.065.023.126.044.188.053.151.108.302.153.456.03.1.04.203.07.303.05.164.109.325.128.496.01.136-.006.272-.039.404-.032.126-.079.248-.115.373a2.159 2.159 0 00-.055.382c-.005.117.004.233 0 .35-.006.074 0 .149.015.222.03.075.062.15.09.225.02.05.011.105.01.158-.003.098-.003.196-.015.293a2.47 2.47 0 00-.02.258c0 .071 0 .142-.007.213-.004.05-.013.098-.023.147-.005.05-.014.099-.02.149a1.87 1.87 0 00-.011.201.653.653 0 01-.017.18c-.011.043-.04.074-.068.108-.03.03-.057.063-.084.095a.332.332 0 01-.085.078c-.037.017-.078.022-.117.033a.491.491 0 01-.136.024c-.067.01-.121-.017-.179-.047l-.048-.106c.056.029.107.058.173.048a.5.5 0 00.133-.023c.038-.011.079-.015.115-.031.033-.02.057-.048.081-.077.027-.032.055-.064.084-.095.028-.032.054-.063.064-.105a.712.712 0 00.015-.177c.001-.068.003-.135.012-.202l.02-.15c.01-.049.018-.097.023-.146.007-.07.005-.141.007-.212.004-.087.009-.173.02-.258.012-.097.012-.195.014-.293.001-.053.008-.106-.013-.156-.028-.075-.063-.149-.088-.225a.82.82 0 01-.013-.224c.004-.117-.005-.232.001-.349.01-.129.024-.258.056-.384.038-.124.084-.246.116-.372.031-.131.046-.267.035-.402-.02-.17-.079-.332-.13-.495-.03-.1-.04-.203-.07-.302-.044-.155-.1-.306-.153-.458-.021-.062-.03-.124-.047-.187.11.184.008.024-.02-.016a1.535 1.535 0 01-.226-.423c-.004-.01-.02-.04-.013-.031.017.022.149.252-.028-.052a3.164 3.164 0 01-.092-.18c-.041-.113-.085-.225-.123-.339-.041-.14-.059-.287-.096-.428-.02-.082-.041-.163-.021-.247.01-.053.016-.107.02-.161a.598.598 0 00.002-.143c-.004-.043-.01-.085-.004-.128.007-.05.015-.1.007-.151-.002-.02-.003-.031-.007-.05-.002-.009-.012-.03-.007-.023.12.158.04.062.01.037a1.656 1.656 0 01-.302-.267c-.067-.062-.139-.119-.197-.19a3.036 3.036 0 01-.235-.316 1.739 1.739 0 00-.133-.183.937.937 0 00-.32-.231c-.03-.009-.059-.02-.09-.026-.174-.038-.362-.011-.529-.087-.02-.012-.04-.022-.058-.035-.036-.028-.038-.043-.067-.076-.02-.022-.041-.04-.064-.058l-.034-.028a.668.668 0 00-.253-.113c-.098-.008-.085.03-.161.077-.057.027-.123.045-.168.09-.023.025-.045.054-.08.06-.022-.036-.045-.072-.066-.109-.016-.029-.01-.067-.026-.096l.052.087a.075.075 0 00-.007-.015c-.018-.026-.049-.035-.078-.041-.076-.01-.15-.028-.227-.037-.096-.002-.19.016-.286.024-.132.011-.266.01-.397-.013-.023-.007-.047-.01-.069-.02-.131-.053-.238-.18-.351-.262-.05-.043-.102-.083-.15-.128-.068-.065-.122-.142-.177-.218-.068-.117-.15-.232-.178-.366-.01-.054-.016-.108-.03-.16-.003-.016-.028-.057-.014-.048.022.013.028.043.042.064.006.008-.01-.017-.015-.026a.54.54 0 00-.21-.121c-.069-.023-.137-.047-.208-.063-.083-.017-.074-.012-.159-.023a1.782 1.782 0 01-.079-.011c-.065-.017-.088-.02-.15-.045-.103-.041-.186-.115-.277-.175-.196-.149-.393-.296-.58-.456-.12-.105-.24-.213-.37-.303-.186-.128-.022-.01-.151-.081-.011-.006-.02-.015-.03-.023-.064-.05-.14-.083-.211-.12-.128-.068-.258-.135-.372-.225a1.12 1.12 0 01-.327-.41c-.006-.012-.046-.09-.051-.103-.027-.064-.036-.135-.05-.202-.014-.09-.029-.18-.027-.27a.627.627 0 00-.018-.12c-.013-.047-.031-.081-.03-.08.018.011.023.035.034.053a2.007 2.007 0 00-.224-.284c-.072-.074-.142-.15-.22-.216l-.045-.109z",
    display: "inline"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M73.035 213.445l-4.885 2.635-3.05.116 1.28 4.533 4.742 9.04 2.55 1.788 4.934 1.473 3.871-.29-2.194-5.405-1.193-2.734-2.518-1.321.055-2.745-2.194-.068z",
    display: "inline"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M72.313 216.419c-.041-.267.013-.541.06-.804.05-.256.116-.51.2-.756.069-.238.172-.463.263-.692.054-.158.117-.314.158-.477.1-.402-.03.109.016-.18.004-.024.017-.044.025-.065.03-.032.059-.066.09-.096.06-.058.121-.113.181-.17.306-.288.617-.57.932-.85.3-.274.621-.494.988-.667.216-.09.45-.118.682-.126a.695.695 0 01.422.122c.104.086.219.155.335.223.178.097.336.224.496.346.12.08.232.169.331.273.11.108.206.229.302.348.115.163.236.32.352.482.155.208.288.431.445.638.078.102.188.233.27.332.138.161.258.343.443.454.1.061.19.092.298.137.33.138.678.212 1.028.274.28.06.565.085.845.14.044.024.096.04.133.074.127.122.304.462.363.574.167.319.298.657.43.992.153.416.345.817.498 1.233.103.295.132.609.159.918.019.234.019.469.02.704.011.215-.021.426-.074.635-.027.117-.089.22-.143.325-.038.074-.059.126-.092.202-.094.2-.176.407-.244.618a1.4 1.4 0 00-.006.55c.007.032.018.063.028.095.17.386.256.803.378 1.206.03.1.064.2.097.299.033.089.064.178.099.266.08.205.098.241.2.43.093.171.208.33.317.49.229.326.454.654.679.982l.074.116c.045.076.09.15.13.228.045.085.067.158.102.246.045.116.039.096.096.21.22.393.433.788.653 1.18.105.181.213.362.346.525.116.142.253.262.391.38.032.032.069.06.096.095a.573.573 0 01.072.12c.039.088.079.177.103.271.016.064.013.131.015.197.005.171-.007.286-.018.458-.018.19-.048.378-.12.556a1.821 1.821 0 01-.167.307c-.076.152-.192.249-.32.353-.131.107-.287.173-.43.26-.146.1-.279.218-.409.336-.146.144-.334.22-.517.304-.178.089-.375.127-.556.208-.108.048-.199.102-.302.159-.058.028-.116.057-.176.083-.062.027-.126.051-.19.076-.166.065-.339.136-.518.161-.064.009-.13.008-.195.013a3.288 3.288 0 01-.656-.118 4.845 4.845 0 01-.371-.107c-.058-.023-.112-.053-.167-.08a7.191 7.191 0 01-.81-.58 2.327 2.327 0 01-.327-.343c-.122-.158-.22-.332-.318-.505-.01-.016-.033-.067-.028-.049.006.023.051.05.032.063-.02.012-.027-.039-.04-.058-.037-.051-.076-.1-.117-.149a.38.38 0 00-.197-.156 2.868 2.868 0 01-.204-.083.488.488 0 00-.146-.05.282.282 0 00-.126.006c-.077.041-.162.064-.245.092-.104.043-.207.012-.31-.014-.072-.017-.144-.034-.216-.046-.05-.01-.095-.01-.14.016-.032.015-.062.033-.094.05l-.068-.12v0l.094-.05a.199.199 0 01.148-.018c.073.01.145.029.217.045.101.027.202.06.304.018.082-.027.167-.051.243-.093a.267.267 0 01.132-.008.449.449 0 01.15.048c.067.031.135.058.203.083a.364.364 0 01.205.155c.108.133.21.269.288.424-.013-.02-.026-.04-.037-.062-.01-.02.024.04.036.06a2.39 2.39 0 00.509.623c.253.216.527.407.808.584.056.027.11.058.166.08.082.033.292.09.371.11.214.056.43.107.652.118.064-.004.13-.004.193-.013.113-.015.232-.054.339-.092.077-.027.295-.11.367-.142.06-.026.117-.056.175-.084.11-.061.189-.109.303-.16.18-.081.377-.12.554-.21.182-.084.368-.16.513-.303.13-.119.265-.236.41-.337.143-.087.299-.153.428-.26.13-.105.24-.197.318-.35.063-.097.124-.195.167-.302.07-.176.1-.364.119-.552.01-.172.021-.285.014-.458-.002-.066-.019-.13-.017-.197 0-.017.027-.03.023-.046-.026-.095-.1-.151-.164-.216-.14-.12-.278-.241-.395-.384-.186-.226-.324-.487-.472-.738-.125-.224-.252-.446-.373-.672-.047-.087-.088-.177-.137-.263l-.146-.251c-.018-.036-.037-.072-.054-.109-.071-.157-.112-.33-.219-.468-.225-.33-.45-.659-.68-.984-.299-.438-.58-.89-.737-1.401-.032-.1-.065-.198-.095-.298-.124-.407-.214-.826-.386-1.216-.01-.032-.02-.064-.027-.097a1.411 1.411 0 01.011-.553c.07-.21.152-.417.246-.617.033-.078.054-.13.092-.205.053-.105.114-.206.14-.322.053-.208.082-.419.072-.633 0-.234-.002-.468-.02-.702-.026-.309-.057-.621-.162-.915-.151-.414-.341-.812-.491-1.226-.133-.336-.27-.668-.433-.992a1.528 1.528 0 00-.233-.36c-.036-.034-.086-.05-.129-.075-.28-.056-.566-.082-.845-.142-.35-.061-.7-.135-1.03-.273-.108-.043-.201-.075-.3-.133-.19-.11-.31-.293-.448-.457-.074-.089-.201-.24-.271-.332-.157-.205-.29-.429-.444-.636-.116-.16-.237-.315-.35-.477-.096-.12-.19-.24-.3-.348a1.798 1.798 0 00-.33-.275c-.16-.122-.317-.25-.495-.347-.116-.067-.232-.134-.335-.22a.663.663 0 00-.416-.13c-.23.007-.462.036-.677.123-.37.17-.687.386-.99.659-.377.332-.757.664-1.106 1.026-.03.03-.056.064-.084.096-.007.02-.018.04-.021.061-.036.223.056-.12-.023.18-.042.162-.105.319-.159.477-.09.23-.19.457-.26.695a5.495 5.495 0 00-.2.75c-.048.265-.101.54-.052.808l-.083-.109z",
    display: "inline"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M28.986 226.258c1.557.79 3.055 1.692 4.63 2.444.593.298 1.25.542 1.741 1.008.25.237.339.42.521.71-1.686-3.078 1.242 2.208.94 1.651-.09-.167-.206-.323-.279-.5-.056-.134.146.254.227.375.217.323.36.48.608.78.566.651 1.138 1.298 1.69 1.96.57.625 1.1 1.285 1.61 1.958.675.955 1.254 1.98 1.784 3.021.405.698.674 1.458.954 2.211.236.658.327 1.355.473 2.035.137.76.46 1.441.788 2.13.136.29.207.45.359.731.061.115.253.455.191.34-.678-1.253-.077-.2.105.047.378.487.836.902 1.254 1.352.275.317.578.597.919.841.37.239.776.406 1.184.565.632.231 1.225.552 1.807.888.685.43 1.452.685 2.214.94.833.278 1.64.628 2.47.915.74.266 1.465.572 2.165.93.692.398 1.404.737 2.132 1.063.783.283 1.579.536 2.374.786.32.18.702.194 1.04.317.174.064.419.215.577.306.596.433 1.304.645 1.995.87l.434.921v0c-.694-.225-1.416-.428-2.015-.86-.045-.027-.485-.29-.548-.315-.335-.134-.735-.114-1.05-.32-.798-.251-1.593-.513-2.384-.782-.729-.33-1.45-.653-2.138-1.063a19.12 19.12 0 00-2.151-.934c-.832-.281-1.636-.64-2.47-.918-.767-.253-1.542-.498-2.232-.927-.576-.336-1.164-.66-1.79-.892-.414-.155-.826-.319-1.205-.55a4.616 4.616 0 01-.94-.834c-.412-.46-.881-.869-1.265-1.354-.676-.873-1.189-1.865-1.666-2.858-.334-.688-.626-1.384-.768-2.143-.143-.68-.242-1.375-.487-2.029-.278-.75-.557-1.501-.958-2.197-.474-.913-.149-.267.025-.014.08.118-.143-.248-.215-.371a8.963 8.963 0 00-.587-.904 24.101 24.101 0 00-1.605-1.961c-.549-.667-1.126-1.312-1.692-1.964-.653-.774-1.048-1.479-1.57-2.38-.075-.128-.31-.504-.218-.387.11.143.186.312.28.468-.15-.254-.278-.51-.487-.722-.475-.483-1.14-.73-1.728-1.032-1.572-.75-3.06-1.663-4.625-2.427l-.418-.925z",
    display: "inline"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M19.57 102.368l2.907 2.405 1.252 1.995 2.81.218.441 2.928 1.82-.889 1.867-1.022-.098-.542 1.904-.316-.212-.316 6.102-1.563-3.36-1.685-2.675-2.152-3.367.36-3.062-.543-4.225.88z",
    display: "inline"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M25.906 114.96l2.243.347 2.648 2.574 1.13.067 1.157 1.807 1.274 1.105 3.005 2.183.064.584 2.781-1.327 3.557-1.352.668-1.756.312-3.36.402-1.024-1.838-.105-2.67.108-2.142.065-2.246.636-.738-.413-2.818.635-.837-.758z",
    display: "inline"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M38.544 130.787l3.666.136 1.882 2.79 4.558 2.233.99 2.236 2.909 2.896 3.543 2.91.437-3.71 2.11-2.77-.488-3.633.49-1.93-1.19-2.3-.781-1.51-3.494.156-1.569.04-2.966.388-1.638.278-2.16.434-1.259-.444h-2l.51-1.649-1.257.266z",
    display: "inline"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M56.092 143.989l3.175 4.545.906 6.823 3.088 5.794 5.689 7.807 4.626 9.997 5.785 4.66 7.11 4.602 4.61 6.233 3.744 9.552 3.116 4.813 4.716 5.356 1.28 4.46 5.685 7.752.912 3.939 3.354 7.397 3.69 2.745 2.902 1.38s3.646 3.608 5.694 5.138c1.757 1.312 3.422 3.562 5.612 3.433 2.035-.119 4.993-1.75 4.807-3.779-.277-3.013-8.04-4.22-8.04-4.22l-5.218-5.894-4.305-3.152-4.33-7.41 1.055-6.001-3.398-3.64-2.83-6.694-4.752-2.535-3.954-6.825-5.504-5.28-2.484-9.037-7.626-2.375-6.83-6.297-2.631-3.898-5.333-8.99-3.717-5.479-3.692-6.597.449-5.335z",
    display: "inline"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M192.097 209.492l-.362-1.47-.231-.933-.819-1.397-.507-.73-.542-.594-.223-.509-.724-.666-1.104-.728-1.425-.366-.322-.177-.677-.211-.416-.721-.504-.67 2.832-1.341.608-1.198.214-1.284-.182-1.535-.207-1.275-.8-1.511-1.268-.637-.032-.516-.76-.38-.966-.57-1.298-.183-.93-.012-.196-1.247-.47-.834-.558-.885-.347-.66-.52-.964-.027-.876-.088-.805-.138-.995-.295-.888-.588-.553-.834-.479-.92-.222-.664-.221-.41-.336-.36-.66-.441-.654-.508-.683-.62-.755-1.083-.79-1.282-.514-.758-.235-.803-.277-1.052-.393-1.37-.597-.444-.34-.38-.68-1.052-.55-.344-.817-.848-.807-.714-.204-.339-.54-.648-.503-.498-.222-.261-.272-.536-.37-.565-.267-.457-.132-.52-.342-.497-.276-.102-.566-.618.202-.696-.35-1.666-.072-1.87.158-.481.529-.642.078-.88-.072-.379.23-.853-.036-.844.09-.843.259-1.091.494-1.572.144-.649-.394-1.04-.094-1.12-.084-1.052.062-.887-.165-.758-.207-.642-.413-1.22.423-.23.5-.688.354-.568.993-.358.049-2.302 1.617-1.446 1.023-1.99 1.21-2.665.84-2.316.705-2.546.514-3.44.476-3.586.366-3.475.2-2.47-.003-3.258-.08-3.005-.3-3.66-.587-3.249-1.492-1.814-.863-1.762-1.793-1.566-1.823-1.187-1.462-.781-1.255-.591-.882-.057-3.418-1.316-2.774-1.004-1.953-1.35-2.014-.711-1.08-.693-.884-.593-1.084-.479-.917-1.085-2.127-.548-1.27-.228-1.335-.301-1.768-.287-.562-.238-1.078-.35-1.01-.234-.309.022-.555-.47-3.125.378-3.204.223-2.927.033-3.268-.164-2.602-.524-2.17-.455-1.367.04-1.002.479-1.309-.19-.501.967-.604.43-.707.015-.659.339-.3.322-.86.38-1.551.004-1.386-.073-1.17-.308-1.49-.285-1.144-.49-1.366-.685-1.794-1.138-1.41-1.284-.718-1.771-.388-2.537.08-1.403-.736-.924-.337-.41-.473-1.462-.821-2.87-1.447-1.135-.717-1.703-.778-2.763-1.136-1.254-.137-.666-.483-.672-.718-.959-.739-.866-.094-1.125-.852-1.87-.534-1.184-.004-1.483-1.079-.757-.22-.729-.42-1.147-.389-2.732-.246-1.874-.26-2.805-.064-.77.119-.62-.118-1.218.16-.622.257-.452.396-.918-.417-1.215-.053-1.38-.725-.37.74-2.445-2.072.148 1.184-.74-.444-2.075-1.037.297 1.185-1.408-1.037-1.688-.572-1.052-.168.508 1.04-.839-.55-1.978-.641-1.32-.442-2.89-.074-1.734.244-1.377.793-.222 1.407.028 1.94.475 1.076.638.494.488.488.812.209 2.077.235-1.382.291-.766.524-.463.39-.5.646.478 1.919.92 1.36 1.996.829 2.088.26 4.234-.862.478.379 2.59-.357.414.513 2.546.378.235.204 2.462.644.682.306 1.269.402.522.509.864.402-1.322.329-.364.421-2.186.086.168.423-2.077.467.3.273-1.905.316.098.542-1.518.852-2.169 1.06-1.218.946-1.302 1.487.244 2.053 1.202.56 1.478.352 1.882.003 2.592-.34.245.461.593.297 1.333-.149 1.484-.486.265.518.473-.106 1.516-.064.73-.57 1.268-.128 1.153.062.963.03 1.428-.138 1.838.105-.402 1.024-.441 1.552.13 1.808-.669 1.756-3.557 1.352-2.317.439-1.906.67-2.599 1.513-.132 3.314 2.057 2.34 3.233.21 2.3-3.132-.223.667 1.334-.815-.37 1.48h2l1.258.445 3.274.455 5.059-1.595 3.494-.155 1.97 3.809-1.11 4.216-1.001 4.117-.437 3.71 1.878 3.235 2.337 2.277 2.697 2.812 2.164 3.027 1.243 2.98 1.356 2.811 2.646 3.258 2.136 3.096 2.004 3.79 1.193 2.104 2.632 3.898 3.527 3.22 3.302 3.077 2.902 1.65 2.776 1.127 1.365 1.615.27 2.895 1.258 2.284 1.539 1.84 1.182 2.408 1.477 2.575 1.647 3.703 1.911 2.643 2.88 1.264 2.754 6.54 2.794 3.226 2.102 2.884 2.482.93-1.103 2.311 1.256 2.492.506 3.436 1.466 2.775 2.359 1.199 1.853 1.889 2.452 1.263 2.154 2.188 1.315 2.176 1.749 1.53 2.864.066 2.47-1.952 2.474-2.627 2.625-.074 2.432.153 2.663-.564.507-1.077 1.103-.552 1.297-2.378.47.425.258.668.354.863.986.815 1.593.127.977-.371.788-1.169 1.132-2.569.829-2.173.046-1.203.705-.623.306-.816 3.627 2.206.99.234.454.602 1.736 1.005 1.482.19.908.905 2.897 1.05 2.014.224 1.522-.33 1.377-.479.948-.6.92-.937.529-1.02 1.01-.676.824-.914.525-1.146.532-1.305 1.488-1.926 1.188-1.77.47 1.984.88 1.092.919.708 1.481 1.171 1.387-.38 1.016-.613 1.344-1.832 1.04-1.86.037-1.76.142-.755.195-2.08-.266-.934-.192-1.91.091-1.771-.28-.483 1.325-.487.913-.598.573-1.014.356-.982z",
    display: "inline"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M130.362 220.507c-.044.314-.092.599-.102 1.152.174-.376.118-.75.102-1.152z",
    display: "inline"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M178.461 221.92s-6.62 1.093-9.911.717c-4.17-.476-8.192-2.015-12.028-3.716-2.351-1.043-6.638-3.935-6.638-3.935s3.994 2.996 6.234 4.06c3.793 1.803 7.823 3.39 11.998 3.843 3.443.375 10.345-.968 10.345-.968z",
    display: "inline"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M149.78 215.963s2.581 2.828 3.756 4.338c.57.733 1.156 1.466 1.593 2.285.945 1.768 2.192 5.598 2.192 5.598s-1.742-3.455-2.866-5.02c-.96-1.337-2.416-2.29-3.28-3.69-.66-1.073-1.395-3.511-1.395-3.511z",
    display: "inline"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M156.657 219.429c-.172 1.001-.713 2.617-1.653 3.024z",
    display: "inline"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M172.036 223.017l-.146 1.295.25 1.286-.975 1.652-.237.883.332.846.33 1.112-1.154 1.304-.132 2.35-.32-2.371 1.286-1.227-.626-1.533.149-1.434.79-1.211z",
    display: "inline"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M161.005 224.484l1.607 1.55 1.704.084 1.008.378 1.085 1.15.471.832.76.713.774.48-2.056-.928-.615-.885-.944-.844-1.049-.637-1.252-.14z",
    display: "inline"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M170.06 225.73l-3.08 2.366-2.382 1.027-1.192-.395 1.134.149 2.474-.98z",
    display: "inline"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M162.81 227.791l.076 1.026 1.505 1.754-1.85-1.304-1.238-.756 1.08.19z",
    display: "inline"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M163.476 231.456c.135-.788-.313-1.444-.884-2.073z",
    display: "inline"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M175.86 224.772s-1.84-1.286-2.89-1.249c-.373.014-.995.517-.995.517 1.36-.066 2.582.24 3.885.732z",
    display: "inline"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M175.566 227.704s-1.485-.886-2.318-1.022c-.605-.098-1.83.169-1.83.169 1.746.126 3.218.371 4.148.853z",
    display: "inline"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M179.965 221.713l-3.442 1.773-.411 2.517-.176 2.278-1.643 2.048 1.333-1.999.329-4.8z",
    display: "inline"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M172.87 221.364s-3.31-.265-4.925-.626c-1.512-.338-3.077-.663-4.421-1.433-.953-.546-2.462-2.19-2.462-2.19l1.38-1.664s-2.161-1.46-3.243-2.187c-.726-.488-1.634-.777-2.18-1.459-.953-1.19-.716-3.06-1.65-4.265-.803-1.035-3.2-2.286-3.2-2.286s.238 1.42.486 2.092c.282.767.736 1.46 1.127 2.179.38.699.86 1.346 1.186 2.071.552 1.23.534 2.717 1.288 3.836.69 1.025 1.904 1.577 2.813 2.414.289.267.465.705.838.831.603.205 1.281-.407 1.895-.24.557.153.873.765 1.369 1.06.55.329 1.182.498 1.758.779.63.307 1.177.816 1.856.992 1.964.509 6.085.096 6.085.096z",
    display: "inline"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M148.717 199.005l-.546 1.243-.106 3.37-1.829 2.395-.69 2.314.714.557.138 2.485 2.585 2.66 5.11-4.555-1.033-2.986-1.525-2.958-1.438-2.165-.976 2.188-.665.938.003-2.264.024-1.754z",
    display: "inline"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M146.202 197.284l1.54 2.1-.71-.091.213 2.282-1.76 3.917-.955 2.591-.234.98-.901-.434-.167.594.775.72-.203 1.628-2.898-.34-1.974.317-.072.494 1.985 1.044 4.758 1.438-4.169-.735-1.897-.941-.854-.288-.603-2.097-.117-4.09 1.372-6.13 1.08-1.307.833.335 1.023-2.775.591-1.12 1.116.854-.197 3.051 1.413 3.227.537-4.888.185-.711z",
    display: "inline"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M140.798 195.537c-.555 1.324-1.059 4.174-1.059 4.174l2.667-6.823s-1.209 1.697-1.608 2.65z",
    display: "inline"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M143.778 212.256s.384 1.853.722 2.732c.343.894.822 1.732 1.314 2.554.528.884 1.175 1.692 1.752 2.545.254.377.446.802.753 1.137.358.391.854.632 1.243.992.287.264.512.59.8.852.325.294.704.522 1.04.803.459.381.878.808 1.331 1.196.612.524 1.252 1.014 1.872 1.527.41.34 1.224 1.026 1.224 1.026s-.573-.723-.907-1.04c-.6-.568-1.319-.998-1.952-1.53a30.458 30.458 0 01-1.462-1.315c-.663-.634-1.225-1.377-1.93-1.964-.277-.23-.632-.356-.894-.602-.404-.378-.685-.869-1.013-1.314-.578-.785-1.165-1.566-1.681-2.393-.455-.73-.902-1.47-1.245-2.258-.412-.948-.967-2.948-.967-2.948z",
    display: "inline"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M148.03 169.007s2.112 2.225 3.157 3.347c1.19 1.277 2.455 2.492 3.548 3.854.981 1.224 2.688 3.863 2.688 3.863s-1.578-2.793-2.552-4.061c-1.067-1.39-2.353-2.6-3.58-3.851-1.059-1.08-3.26-3.152-3.26-3.152z",
    display: "inline"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M150.146 168.298s2.245 2.075 3.264 3.21c1.178 1.313 2.248 2.722 3.284 4.15.838 1.156 2.367 3.57 2.367 3.57s-1.45-2.528-2.284-3.72c-1.025-1.469-2.107-2.908-3.33-4.217-1.013-1.085-3.3-2.993-3.3-2.993z",
    display: "inline"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M146.83 219.532s2.414 5.442 2.101 8.268c-.336 3.032-4.14 8.162-4.14 8.162s3.588-5.254 3.915-8.293c.298-2.767-1.877-8.137-1.877-8.137z",
    display: "inline"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M149.596 222.002s.736 3.967.366 5.904c-.35 1.833-2.379 5.068-2.379 5.068s1.811-3.354 2.155-5.198c.352-1.893-.142-5.774-.142-5.774z",
    display: "inline"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M146.632 218.769l-5.431.1s-4.249 1.842-6.305 2.528c-2.057.686-6 1.613-6 1.613s3.975-.692 6.098-1.36c2.123-.668 6.572-2.703 6.572-2.703z",
    display: "inline"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M145.336 215.252l-2.925.078s-5.492 2.884-8.159 3.811c-2.666.928-9.245 1.919-9.245 1.919s6.17-1.152 8.76-2.095c2.591-.944 8.154-3.487 8.154-3.487z",
    display: "inline"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M142.566 215.155l-.828 4.089-.68.142.881-3.959z",
    display: "inline"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M188.446 223.015s-.257-.951-.622-1.233c-.794-.613-1.94-.605-2.943-.633-1.292-.035-3.829.607-3.829.607s3.161-.588 4.694-.263c.507.108.932.455 1.384.71.449.253 1.316.812 1.316.812z",
    display: "inline"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M191.78 209.998s-.088-1.443-.445-2.04c-.299-.5-.812-.866-1.328-1.137-.666-.35-2.182-.58-2.182-.58l-.948-1.594s-1.438-.273-2.1-.046c-.684.234-1.296.755-1.681 1.365-.262.414-.252.948-.348 1.429-.092.462-.218 1.397-.218 1.397s.047-.929.196-1.363c.164-.48.43-.93.752-1.322.343-.417.726-.856 1.227-1.06.548-.223 1.772-.109 1.772-.109l1.097 1.567s1.72.076 2.466.452c.462.233.86.621 1.135 1.06.365.586.605 1.98.605 1.98z",
    display: "inline"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M188.958 213.145c-.553.104-2.138.15-2.64.042.733.45 2.198.147 2.64-.042z",
    display: "inline"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M184.826 191.316s-1.174-.68-1.817-.656c-.695.028-1.266.58-1.902.862-.536.237-1.129.37-1.613.7-.396.27-.804.587-1.013 1.018-.295.607-.306 1.338-.244 2.01.081.887.289 1.82.8 2.552.253.362 1.052.808 1.052.808s-1.042-.57-1.377-1.037c-.466-.647-.664-1.478-.756-2.27-.088-.762-.125-1.6.209-2.291.203-.42.63-.7 1.014-.966.576-.399 1.249-.637 1.892-.916.634-.276 1.243-.786 1.934-.75.681.037 1.821.936 1.821.936z",
    display: "inline"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M180.396 199.033s2.732 1.002 4.03.602c.505-.156.715-.798 1.163-1.077.357-.223.834-.212 1.177-.454.387-.274.925-1.081.925-1.081s-.688.502-1.062.704c-.42.227-.92.298-1.317.565-.381.256-.55.806-.98.968-1.23.463-3.936-.227-3.936-.227z",
    display: "inline"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeWidth: 0.367,
    d: "M172.505 184.72c.207-.307.321-.756.178-1.097-.12-.288-.458-.602-.764-.542-.529.105-.726.847-.863 1.368a.936.936 0 00.027.555c.072.193.282.305.384.485.09.16.175.332.195.514.033.301-.028.615-.13.9-.148.413-.378.81-.683 1.126-.25.26-.56.486-.904.595-.27.085-.574-.042-.847.027-.137.035-.385.05-.378.191.009.194.348.201.543.213.24.015.474-.094.699-.179.334-.127.668-.276.954-.49.247-.185.455-.421.637-.67.137-.188.265-.39.336-.612.069-.216.09-.449.079-.675a2.311 2.311 0 00-.13-.598c-.046-.14-.124-.268-.18-.405-.055-.132-.236-.283-.153-.4.092-.13.324.056.477.015.198-.052.41-.15.523-.32z",
    display: "inline"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeWidth: 0.367,
    d: "M172.374 183.245s-.577-.84-.917-1.218c-.262-.29-.518-.61-.86-.801-.353-.197-.768-.275-1.17-.323a6.822 6.822 0 00-1.858.058c-.77.121-1.666.127-2.246.647-.277.248-.256.7-.424 1.033-.147.288-.327.559-.506.828-.137.207-.36.368-.435.605-.1.318.01 1.003.01 1.003s.12-.657.256-.96c.226-.506.643-.907.912-1.393.168-.304.17-.722.436-.947.516-.439 1.29-.436 1.959-.543.607-.097 1.236-.18 1.844-.086.366.056.711.218 1.043.383.29.144.57.319.82.525.423.349 1.135 1.189 1.135 1.189z",
    display: "inline"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeWidth: 0.367,
    d: "M149.708 187.954a.653.653 0 00-.554-.266.504.504 0 00-.378.268c-.483.955.462 2.217.062 3.209-.228.564-.8.93-1.291 1.289-.396.29-1.307.68-1.307.68s.96-.224 1.372-.478c.545-.337.992-.828 1.38-1.338.3-.396.573-.834.715-1.311.105-.354.09-.734.088-1.103-.002-.318.095-.689-.087-.95z",
    display: "inline"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeWidth: 0.367,
    d: "M149.557 187.93s-.425-.441-.703-.541c-.187-.068-.595-.022-.595-.022l-.523-.74s-.975-.095-1.452-.202c-.493-.11-.947-.378-1.446-.453-.578-.086-1.189-.141-1.753.011-.585.158-1.079.559-1.576.904-.482.334-.964.684-1.353 1.122-.159.178-.31.376-.39.601-.144.397-.29.858-.15 1.257.15.431.671.622.974.964.314.354.6.733.868 1.122.444.64 1.227 1.988 1.227 1.988s-.641-1.498-1.107-2.16c-.484-.689-1.426-1.057-1.726-1.844a1.789 1.789 0 01.032-1.319c.296-.66 1.003-1.052 1.582-1.486.489-.367.992-.765 1.58-.93.552-.157 1.152-.102 1.722-.033.479.058.926.278 1.4.37.48.094 1.457.184 1.457.184l.553.787s.493-.04.725.029c.244.072.654.391.654.391z",
    display: "inline"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeWidth: 0.367,
    d: "M181.27 190.012l-6.195 3.14s.122-1.794.032-2.684c-.112-1.108-.335-2.216-.71-3.266-.442-1.242-1.793-3.526-1.793-3.526s1.17 2.32 1.577 3.549c.352 1.06.62 2.16.739 3.27.114 1.067-.03 3.218-.03 3.218z",
    display: "inline"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeWidth: 0.367,
    d: "M163.8 186.447s-.746.884-.922 1.421c-.257.785.138 1.698-.143 2.475-.209.578-.766.965-1.095 1.484-.18.282-.26.627-.477.881-.428.5-.949.978-1.569 1.2-.362.13-.772.087-1.155.041-.802-.094-1.56-.417-2.335-.647-.673-.2-1.434-.23-2.006-.635-.776-.55-1.218-1.471-1.712-2.285-.607-.999-1.52-3.16-1.52-3.16l-1.567.186 1.39.028s.907 2.17 1.524 3.165c.499.805.979 1.684 1.744 2.242.701.512 1.62.628 2.446.897.571.186 1.138.416 1.734.494.472.062.973.113 1.429-.027.689-.211 1.329-.645 1.811-1.18.288-.318.376-.772.588-1.145.272-.48.485-1.016.876-1.405.045-.046.132-.046.164-.101.382-.664-.108-1.55.062-2.296.133-.582.734-1.633.734-1.633z",
    display: "inline"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeWidth: 0.367,
    d: "M143.313 195.017l1.05 1.319 1.16.378 1.505 1.03 1.8.785 1.788 2.528 2.664 1.29.522 2.538 2.718 3.93 4.538 4.11 5.332 3.441 4.829 2.25 3.282 1.04 2.771.083 2.942-.465.435 2.163 1.798-.49 1.777-.217 2.736.295-.066-3.296 1.004.076-1.129-1.715.854-.128.11-.515-.593-.457.429-.515-.497-.962-1.278-.904-.04-1.527-1.075-.973-1.071-1.356-.694-.452-.617 1.709-.5.295-.149-2.007.443-2.23 2.074-1.936-.238-1.009.994-.685-.089-.493-1.562-.666-.156-.646.369-.414-.734-.134-1.85-.244-1.653-.544-1.27-1.633-.563-2.281.174-2.538-2.04 1.556-1.216 2.945-.444-2.943-4.087-.094 4.707-.714-.325-.715-1.974.292 2.066-1.681.344-1.298-1.067.322.848-1.891-1.392.568.87-2.14-1.073 1.233.502-2.838-1.045 2.22-1.342 1.474-1.277.253.379-1.54.379-1.255-1.418.425-2.2-1.386s-1.156-1.74-1.537-2.355l-.844 1.956-.917 2.82-.23 2.637-1.509 2.575-1.738 1.188s.208 2.157.309 3.336l-1.513 2.65-.104-3.81-2.017.543 1.582-2.197-2.81-.395-1.19-.162-3.152.568-2.002.71 4.035-2.606-2.68-.221-1.747-.158-2.203 1.591z",
    display: "inline"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M156.367 182.193c.032.482.152.955.247 1.429.067.332.229.99.229.99s-.7-1.076-.787-1.691c-.116-.816.378-2.444.378-2.444.096.59-.105 1.145-.067 1.716z",
    display: "inline"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M157.654 184.05c-.146-.124-.434-.17-.573-.038-.106.102-.086.328.008.441.102.122.35-.015.466.094.241.229.193.638.248.966.05.302.04.611.074.916.08.715.308 2.136.308 2.136s.073-1.489-.011-2.226c-.09-.777.075-1.78-.52-2.289z",
    display: "inline"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M157.246 184.865c.185.235-.114.643.045.895.044.07.176.046.218.117.444.754-.618 1.973-.033 2.624.094.104.418.04.418.04l-.417.307.578.323-.953-.284s-.273-.701-.337-1.07a4.706 4.706 0 01-.049-1.185c.04-.49.541-1.019.295-1.444-.129-.224-.615-.016-.735-.245-.053-.103-.004-.277.098-.333.266-.145.684.018.872.256z",
    display: "inline"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M155.431 178.13s-1.576-.26-2.315-.548c-.574-.225-1.02-.734-1.61-.91-.503-.148-1.049-.155-1.57-.097a5.012 5.012 0 00-1.744.51c-1.09.565-1.917 1.536-2.882 2.298-.822.649-1.582 1.388-2.475 1.934-.871.533-1.875.813-2.778 1.289-.453.238-1.32.78-1.32.78s.784.04 1.165.127c.238.054.692.242.692.242s.512-.482.834-.597c.232-.084.503.021.738-.052.405-.125.735-.421 1.094-.644 1.602-.994 3.258-1.921 4.734-3.093.5-.397.851-.967 1.38-1.322.294-.197.621-.373.97-.431.3-.05.618-.01.906.082.23.074.417.244.627.364.196.113.369.288.59.336.97.21 2.964-.268 2.964-.268z",
    display: "inline"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M153.293 181.643l-2.08 1.905-3.293 3.1-.861.085 2.847-3.07-.87 1.415z",
    display: "inline"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M148.188 187.359l2.845-2.323 2.41-1.776z",
    display: "inline"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M151.374 187.672l4.55-2.75-2.699 1.765z",
    display: "inline"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M154.637 184.285l-2.026 1.878-1.896 1.219 1.628-1.353 2.216-1.66z",
    display: "inline"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M159.222 191.95c-.788.175-1.014-.006-1.365-.109.498-.129.937-.031 1.365.11z",
    display: "inline"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M152.408 190.3l2.11-.055c-.795-.075-1.586-.146-2.11.055z",
    display: "inline"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M154.022 190.979l.912.45-1.29.128.583-.227z",
    display: "inline"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M156.222 192.144l-.263.704-.386.255.924.205.296-.286-.541.017z",
    display: "inline"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M154.512 183.31l-.715-.26-.259.48-.04.293.483.09.014-.379.668-.273z",
    display: "inline"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M146.409 169.384l-2.846 1.886-2.343 2.083-2.022 2.475-1.458 2.237-.756 2.184 1.07.027-1.197 1.289-.766 1.317-.756 1.342.911-2.521.711-2.64 1.093-2.632 1.853-2.34 1.31-1.387z",
    display: "inline"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M138.3 183.87l.452.931-.14 1.026-.737 1.312-.304 1.22-.145 1.714.305 2.816.355 1.923.206 1.622.379.998 1.062 1.832-1.538-2.2-.495-3.144-.47-3.695.002-2.042.466-1.234.792-1.255.027-.751z",
    display: "inline"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M135.335 184.224s-.93 3.614-1.19 5.457c-.227 1.609-.322 4.863-.322 4.863s-.294-3.381-.061-5.048c.254-1.816 1.573-5.272 1.573-5.272z",
    display: "inline"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M175.092 184.152c1.312.611 2.255 2.039 3.208 3.07z",
    display: "inline"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M174.378 181.631c1.804 1.486 3.396 3.157 4.667 5.107z",
    display: "inline"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M175.713 181.05c1.02 1.112 3.202 1.608 3.059 3.336-.634-.909-2.02-2.214-3.06-3.336z",
    display: "inline"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M173.92 179.676c.558.381.941.849 1.174 1.391z",
    display: "inline"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M158.173 173.898l1.332 1.19.271 1.448 1.365 1.314 1.661-.227.705 1.272-1.229-2.737-1.152-.293-1.03-.511.694-.66z",
    display: "inline"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M141.7 171.49s-1.328.662-1.965 1.04c-.706.418-1.442.81-2.053 1.356-.634.567-1.173 1.245-1.634 1.96-.448.694-.674 1.513-1.08 2.232-.537.949-1.788 2.737-1.788 2.737s2.174-3.788 3.455-5.551c.292-.402.587-.812.96-1.14 1.222-1.072 4.105-2.634 4.105-2.634z",
    display: "inline"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M133.984 180.305s1.13.473 1.386.975c.447.874-.035 2.944-.035 2.944s.149-1.664-.142-2.417c-.23-.6-1.209-1.502-1.209-1.502z",
    display: "inline"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M128.069 177.479s.15 1.122.456 1.574c.702 1.038 1.97 1.547 2.959 2.315.217.169.485.286.652.504.383.497.627 1.116.73 1.736.163.993-.182 2.006-.212 3.012-.02.678-.283 1.427.018 2.034.204.411 1.09.842 1.09.842s-.776-.509-.936-.914c-.582-1.475.465-3.185.215-4.75-.109-.678-.325-1.372-.73-1.925-.86-1.174-2.522-1.566-3.428-2.705-.396-.497-.814-1.723-.814-1.723z",
    display: "inline"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M128.936 176.993s1.15 1.44 1.829 2.057c.738.67 2.415 1.765 2.415 1.765s-1.824-.818-2.553-1.478c-.714-.646-1.69-2.344-1.69-2.344z",
    display: "inline"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M137.803 183.993s-.378 1.896-.627 2.83c-.195.733-.518 1.432-.677 2.174-.098.456-.17 1.387-.17 1.387s.077-1.44.216-2.145c.285-1.449 1.258-4.246 1.258-4.246z",
    display: "inline"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M135.926 191.477c.125.44-.314 2.666-.177 3.99.11 1.07.298 2.176.8 3.129.342.651 1.352.933 1.453 1.662.178 1.283-.386 3.316-1.667 3.51-.93.14-1.593-1.189-1.91-2.073-.577-1.61.044-3.431.291-5.124.252-1.727 1.21-5.094 1.21-5.094z",
    display: "inline"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M127.555 176.657s-.94 4.617-1.337 6.939c-.35 2.045-.923 4.082-.921 6.157.002 2.91.935 5.744 1.305 8.63.191 1.491.304 2.992.473 4.487.164 1.448.362 2.892.526 4.34.237 2.088.22 4.214.663 6.268.184.852.601 1.639.823 2.482.213.808.6 1.632.484 2.46-.053.38-.195.825-.522 1.026-.398.243-1.04-.3-1.4-.003-.28.23-.206 1.067-.206 1.067l3.808-.777s-.187-1.671-.335-2.499c-.35-1.97-.87-3.907-1.306-5.86-.47-2.11-1.052-4.197-1.415-6.327-.278-1.634-.302-3.303-.58-4.936-.2-1.169-.569-2.304-.777-3.47-.3-1.691-.5-3.399-.68-5.107-.102-.967-.254-1.937-.226-2.909.115-4.024 1.623-11.968 1.623-11.968z",
    display: "inline"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M128.098 198.802s1.692 2.268 2.55 3.393c.503.659.848 1.485 1.524 1.966.536.381 1.871.63 1.871.63s-1.875-.22-2.595-.764c-.656-.495-.874-1.392-1.317-2.085-.672-1.05-2.033-3.14-2.033-3.14z",
    display: "inline"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M129.555 204.33s1.3 1.588 2.16 2.109c.567.342 1.888.614 1.888.614s-1.775.06-2.48-.39c-.79-.503-1.283-1.457-1.568-2.333z",
    display: "inline"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M128.676 201.308l1.62 2.506 1.823 1.339 1.693.913 3.29.965-3.647-1.362-2.057-1.313-1.418-1.103z",
    display: "inline"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M133.681 206.298s1.527 1.125 2.028 1.906c.224.35.13.864.398 1.18.57.674 2.334 1.249 2.334 1.249l-1.08-1.782s-1.054-.868-1.612-1.26c-.666-.466-2.068-1.293-2.068-1.293z",
    display: "inline"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M130.119 180.645c.798 1.668.008 3.743-.482 5.526-.436 1.59-1.831 2.84-2.145 4.458-.385 1.986.607 4.043.396 6.054-.106 1.014-.828 2.944-.828 2.944s-.689-2.665-.845-4.027c-.343-2.984-.377-6.01-.196-9.008.082-1.36.325-2.707.578-4.045.366-1.935 1.357-5.748 1.357-5.748s.105 2.033.654 2.83c.344.5 1.249.469 1.51 1.016z",
    display: "inline"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M130.887 182.292c.893 1.712.3 3.64-.937 5.543 1.34-1.747 2.232-3.549.937-5.543z",
    display: "inline"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M141.232 215.253c-.056-.346-.755-.531-1.01-.291-.129.12.07.344.113.514.035.14.119.416.119.416s.224-.242.352-.347c.132-.11.453-.122.426-.292z",
    display: "inline"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M135.863 217.95s-.444.061-.654.002c-.226-.063-.368-.331-.6-.367-.183-.028-.428-.014-.539.134-.063.084-.045.226.011.315.063.099.23.078.313.16.056.055.056.152.112.207.053.053.2.106.2.106z",
    display: "inline"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M140.148 221.34c.85.399 1.283 1.423 1.635 2.292.547 1.348.808 2.868.654 4.314-.144 1.36-.863 2.602-1.452 3.836-.382.802-.841 1.57-1.344 2.302-.469.686-.86 1.492-1.552 1.95-.586.387-1.335.658-2.03.562-.69-.095-1.104-.948-1.787-1.083-.47-.093-1.178-.192-1.422.221-.253.428.37.924.51 1.4.268.911.632 2.779.632 2.779s-3.383-2.603-3.026-4.326c.207-1 1.629-1.323 2.61-1.608.587-.17 1.227-.101 1.833-.025.855.107 1.634.717 2.494.673.415-.02 1.125-.031 1.163-.444.076-.821-1.455-.792-2.11-1.292-.39-.298-1.073-1.01-1.073-1.01s1.581 1.13 2.48 1.467c.339.126.738.346 1.066.196.437-.2.49-.826.728-1.243.09-.16.256-.299.266-.482.02-.389-.172-.806-.452-1.077-.689-.666-2.686-1.023-2.686-1.023s1.588.092 2.376.196c.477.063.994.484 1.418.258.51-.272.922-1.06.693-1.59-.57-1.32-2.748.022-4.058-1.46 0 0 3.404 1.174 3.97-.022.15-.316-.498-.507-.662-.816-.283-.531-.324-1.16-.528-1.726-.286-.79-.52-1.62-.975-2.326-.196-.303-.87-.457-.738-.793.167-.424.953-.294 1.367-.1z",
    display: "inline"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M144.07 215.254c-.269 1.147-.633 2.333-.894 3.609.293-1.21.644-2.406.894-3.609z",
    display: "inline"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M144.773 215.262c-.268 1.146-.422 2.297-.683 3.573.293-1.21.434-2.371.683-3.573z",
    display: "inline"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M145.308 216.585c-.269 1.147-.164.938-.425 2.214.293-1.21.175-1.012.425-2.214z",
    display: "inline"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M145.825 217.54c-.268 1.147-.033 0-.294 1.276.293-1.21.045-.073.294-1.275z",
    display: "inline"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M146.371 218.398c-.061.17-.075.216-.146.38.06-.167.08-.212.146-.38z",
    display: "inline"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M143.274 215.349c-.269 1.147-.623 2.244-.884 3.52.293-1.21.634-2.318.884-3.52z",
    display: "inline"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M154.253 228.7l-4.003-1.993c1.3.737 2.603 1.465 4.003 1.992z",
    display: "inline"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M153.888 229.366c-.092.613-1.822 3.456-1.973 4.042-.042.165-.286-.022-.25-.105.273-.628 2-3.534 2.077-3.954.01-.048.154-.031.146.017z",
    display: "inline"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M148.376 233.568c-.06.122-.069.3.016.407.232.293.712.235 1.08.299.24.041.728.052.728.052s-.498-.145-.74-.237c-.256-.098-.535-.167-.75-.336-.09-.07-.096-.254-.209-.271-.05-.008-.102.041-.125.086z",
    display: "inline"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M150.736 235.462s-.939-.151-1.334-.394c-.196-.12-.271-.393-.473-.503-.334-.183-1.123-.21-1.123-.21s.643.228.896.444c.158.134.189.391.361.506.272.18.63.178.955.215.229.027.692.007.692.007z",
    display: "inline"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M143.897 234.408c.281.126.283.617.18.906-.083.23-.36.594-.567.466-.2-.124.098-.462.157-.69.057-.22.048-.476.187-.656.01-.013.028-.032.043-.026z",
    display: "inline"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M140.4 234.67s.864.259 1.306.237c.559-.028 1.237-.05 1.612-.464.196-.217.394-.69.158-.862-.3-.22-.64.386-.986.522-.671.265-2.09.566-2.09.566z",
    display: "inline"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M141.263 215.836c-.262.892-.565 2.321-.753 3.395.308-1.174.587-2.468.753-3.395z",
    display: "inline"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M140.64 216.138c-.263.892-.574 2.299-.762 3.373.308-1.175.595-2.446.762-3.373z",
    display: "inline"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M140.084 216.426c-.262.892-.634 2.25-.822 3.324.308-1.174.656-2.398.822-3.324z",
    display: "inline"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M139.345 216.804c-.262.891-.696 2.267-.884 3.341.309-1.174.717-2.415.884-3.341z",
    display: "inline"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M138.643 217.116c-.262.891-.695 2.268-.883 3.342.308-1.175.717-2.416.883-3.342z",
    display: "inline"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M137.975 217.408c-.262.89-.744 2.203-.933 3.277.309-1.174.767-2.351.933-3.277z",
    display: "inline"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M137.435 217.635c-.503.659-.771 2.285-1.022 3.358.4-1.127.616-2.529 1.022-3.358z",
    display: "inline"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M136.635 217.947c-.503.659-.53 1.978-1.027 3.245.596-1.11.621-2.416 1.027-3.245z",
    display: "inline"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M135.997 218.277c-.502.659-.53 1.979-1.027 3.246.597-1.11.621-2.417 1.027-3.246z",
    display: "inline"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M135.063 218.755c-.333.754-.375 1.672-.871 2.939.596-1.11.6-2.093.871-2.939z",
    display: "inline"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M134.317 218.863c-.269.709-.54 1.836-1.035 3.103.596-1.11.885-2.207 1.035-3.103z",
    display: "inline"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M133.68 219.076c-.269.708-.699 1.827-1.195 3.094.596-1.11 1.045-2.199 1.195-3.094z",
    display: "inline"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M132.883 219.395c-.269.709-.708 1.746-1.204 3.013.596-1.11 1.053-2.118 1.204-3.013z",
    display: "inline"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M131.767 219.577c-.269.708-.864 1.268-1.502 3.098.823-1.993 1.374-2.292 1.502-3.098z",
    display: "inline"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M128.891 220.912c.173.185.443.52.716.62-.189-.172-.475-.492-.716-.62z",
    display: "inline"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M128.3 220.956c.277.373.661.706 1.087 1.024-.4-.38-.726-.738-1.088-1.024z",
    display: "inline"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M127.38 221.136c.508.27.888.584 1.199.92a9.682 9.682 0 01-1.199-.92z",
    display: "inline"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M131.697 239.05l2.19 1.48-2.47 1.952-2.864-.066s-1.168-1.002-1.749-1.53l-1.315-2.176-2.154-2.188-2.452-1.263-1.853-1.889-2.359-1.199-1.467-2.775-.505-3.436-1.256-2.492 7.037 2.535s.876 1.527 1.641 1.793c.336.117.756-.362 1.055-.169.364.236.339 1.257.339 1.257l.979-.115s1.69-.022 2.233-.565c.384-.383.428-1.036.4-1.577-.025-.48-.499-1.35-.499-1.35s1.107.76 1.488 1.297c.348.492.484 1.107.67 1.68.128.39.296.782.304 1.192.015.726-.212 1.444-.449 2.13-.249.723-1.01 2.06-1.01 2.06l2.745-.148-.962 1.314-.853.198z",
    display: "inline"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M124.585 224.912l1.179.521 3.295-1.513s-.034-.53-.075-.793c-.046-.297-.192-.88-.192-.88s-6.576-2.99-10.07-3.81c-1.398-.328-4.285-.425-4.285-.425l-.346.161 1.664 1.786-1.287 1.044s2.593 1.06 3.884 1.603c.547.23 1.115.415 1.636.7.428.233.75.665 1.212.82.46.155 1.45.079 1.45.079l1.71-1.571s.083.59.271.8c.152.169.398.235.62.285.265.06.817.014.817.014z",
    display: "inline"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M123.607 225.001s-.417 1.012-.86 1.26c-.438.243-1.006.14-1.501.067-.755-.112-2.16-.763-2.16-.763s1.43.42 2.167.5c.467.053.98.185 1.408-.008.431-.194.946-1.056.946-1.056z",
    display: "inline"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M123.202 223.886s-.351.996-.779 1.219c-.935.488-2.12.033-3.162-.125-1.925-.291-5.643-1.507-5.643-1.507s3.74.98 5.65 1.245c1.016.142 2.127.586 3.07.184.41-.175.864-1.016.864-1.016z",
    display: "inline"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M119.377 219.323s-.899-1.658-1.673-2.114c-1.556-.918-5.347-.89-5.347-.89s3.432.381 4.932 1.157c.825.427 2.088 1.847 2.088 1.847z",
    display: "inline"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M113.914 219.05l-1.517-1.538-1.79.082.285-1.217-.795-1.468-3.804-2.87.875 2.078 4.896 6.11 1.404.492 1.045-1.22z",
    display: "inline"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M127.538 213.498s-.796 1.43-1.372 1.998c-.542.533-1.168 1.058-1.9 1.26-.934.258-2.903-.136-2.903-.136s-.78-.854-1.217-1.231c-.482-.417-.914-1.009-1.539-1.132-.332-.065-.985.245-.985.245s1.195 1.798 1.796 2.695c.4.597 1.205 1.788 1.205 1.788l2.18.773s-.51-1.264-.798-1.882c-.166-.36-.536-1.061-.536-1.061s1.898.512 2.82.3c.41-.093.739-.407 1.07-.665.542-.42 1.09-.86 1.486-1.42.324-.457.693-1.532.693-1.532z",
    display: "inline"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M126.957 209.88s-.63 1.312-1.045 1.906c-.298.426-.579.913-1.029 1.175-1.027.599-2.304.684-3.492.72-.823.026-1.63-.23-2.445-.349-.516-.075-1.132.087-1.548-.227-.752-.568-.629-1.8-1.16-2.578-.353-.516-.786-1.006-1.315-1.34-.443-.278-.974-.398-1.486-.507-.397-.085-1-.458-1.214-.112-.295.478.568.972.891 1.432.495.704.888 1.542 1.6 2.026.273.186.65.146.95.286.623.291 1.078.896 1.723 1.137 1.225.456 2.582.55 3.888.508 1.284-.042 2.662-.114 3.781-.744.664-.374 1.188-1.013 1.538-1.69.258-.498.363-1.642.363-1.642z",
    display: "inline"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M126.739 204.813s-1.035 3.306-2.359 4.231c-.358.25-.858.199-1.295.207a4.624 4.624 0 01-1.274-.156c-.167-.045-.31-.16-.478-.203-.481-.12-.99-.067-1.48-.13-1.041-.133-2.088-.264-3.105-.521a18.717 18.717 0 01-3.098-1.06c-.342-.155-.98-.559-.98-.559s2.28.92 3.456 1.273c.667.2 1.347.358 2.033.477 1.179.204 2.383.232 3.567.402.342.05.677.149 1.021.178.46.04.982.222 1.386-.002 1.427-.788 2.606-4.137 2.606-4.137z",
    display: "inline"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M121.937 206.497s-1.118-.11-1.679-.103c-.646.007-1.285.174-1.93.162a9.325 9.325 0 01-1.983-.24c-.761-.181-1.525-.415-2.208-.797-.638-.358-1.24-.815-1.714-1.372-.549-.646-.932-1.429-1.248-2.215-.105-.261-.21-.818-.21-.818l.06 1.245s.377.62.568.93c.268.435.45.939.808 1.304.32.328.758.516 1.152.749.725.428 1.435.905 2.225 1.194.496.181 1.029.242 1.55.328.368.06.738.14 1.111.133.339-.006.67-.095 1.003-.155.328-.06.65-.154.979-.203.501-.076 1.516-.142 1.516-.142z",
    display: "inline"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M122.494 204.253l.162 1.336 1.88.776-1.386-.824-.15-.76.239-.262z",
    display: "inline"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M121.77 204.166l-.353.84-.189-.403z",
    display: "inline"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M121.017 204.068l-.562 1.123-.044-.583z",
    display: "inline"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M119.708 204.114l-.257.905-.467-.656z",
    display: "inline"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M120.15 204.191l-.193.962-.209.02z",
    display: "inline"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M118.412 203.848l-.309.964.413-.205-.02-.452z",
    display: "inline"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M117.718 203.541c-.8.25-.178.847-.252 1.273z",
    display: "inline"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M116.373 203.327l-.036 1.011-.151-.532z",
    display: "inline"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M115.756 203.162l-.004 1.292-.246-.757z",
    display: "inline"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M114.974 202.91l.293.746c-.426-.184-.463-.445-.293-.746z",
    display: "inline"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M114.826 202.713l-.69-.773-.383.738.423.528.2.59.59 1.078.563.32-.595-.926-.283-.958z",
    display: "inline"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M120.56 206.786l.984.362-.873.207.035.379 1.052-.02.188-.087.308-.881-.237-1.224-.147-.71-.018-.643.274.796.243 1.378-.067 1.175-.704.534-.863-.076-.271-.192.7-.62z",
    display: "inline"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M119.672 208.48l.096-.535.539-.33.34-.022-.943.079-.314.497z",
    display: "inline"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M118.143 207.194l.205.635-.483.261.067-.28-.185-.459z",
    display: "inline"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M119.028 207.973l.487-.455.5-.078.022-.294-1.002.16-.132.287z",
    display: "inline"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M117.453 207.213l-.218.67-.316-.814z",
    display: "inline"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M116.469 207.075c-.38.068-.699.162-.824.34.185-.327-.101-.447-.32-.597z",
    display: "inline"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M115.191 206.728c-.51-.042-1.077-.187-1.342.207.422-.354-.083-.767-.403-1.167z",
    display: "inline"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M115.709 205.071l1.406-.114 1.204.468-1.035-.239h-1.399z",
    display: "inline"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M115.121 194.997s1.324 1.507 2.036 2.212c1.018 1.008 2.32 1.74 3.191 2.877.235.308.75.72.525 1.035-.225.314-1.149-.163-1.149-.163s.883.866 1.267.6c.287-.197.045-.717-.084-1.04-.212-.533-.673-.935-1.078-1.34-.608-.607-1.361-1.05-2.007-1.615-.935-.817-2.7-2.566-2.7-2.566z",
    display: "inline"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M121.742 183.479s-.58 2.83-.717 4.266c-.085.898.077 1.813-.06 2.704-.096.616.098 1.802-.526 1.795-.645-.007-.32-1.248-.506-1.866-.096-.319-.015-.799-.312-.949-.35-.176-.787.153-1.114.367-.376.246-.9 1.003-.9 1.003s.9-.947 1.474-.898c.284.024.49.323.643.563.372.583-.099 1.858.58 1.992.382.075.584-.552.727-.914.35-.88.165-1.885.238-2.828.05-.651.081-1.303.137-1.953.095-1.096.336-3.282.336-3.282z",
    display: "inline"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M117.957 191.34s-.54.673-.64 1.08c-.132.537.048 1.105.086 1.657.046.686.754 1.69.17 2.054-.33.206-.726-.325-1.003-.599-.339-.336-.292-1.38-.744-1.223-.255.088 0 .551.096.804.118.31.299.624.568.818.342.247.883.617 1.214.356.71-.558-.19-1.802-.135-2.703.046-.758.388-2.244.388-2.244z",
    display: "inline"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M120.852 193.114c.7.543 1 1.467 1.404 2.255.775 1.514 1.558 3.062 1.934 4.72.167.734.094 1.504.132 2.256.053 1.058.132 3.176.132 3.176s-.855-2.764-1.338-4.127c-.642-1.809-1.126-3.702-2.073-5.37-.558-.984-1.695-1.612-2.09-2.67-.274-.735-.133-1.565-.118-2.349.005-.288.076-.862.076-.862s.493.658.608 1.044c.146.49-.234 1.128.079 1.532.268.347.908.127 1.254.395z",
    display: "inline"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M114.89 202.68s.47.323.737.418c.267.095.558.109.84.141.149.017.3.007.448.028.386.055.756.197 1.142.255.282.043.569.057.854.07.244.01.489 0 .733.006.147.002.294.014.44.011.278-.006.567.03.83-.055.175-.055.288-.257.468-.287.273-.045.564.056.807.186.343.183.848.8.848.8s-.514-.05-.77-.08c-.35-.042-.694-.13-1.046-.145-.46-.019-.918.077-1.378.075-.447-.002-.899 0-1.338-.084-.394-.075-.756-.275-1.146-.37-.53-.13-1.115-.05-1.611-.274-.336-.151-.858-.695-.858-.695z",
    display: "inline"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M124.925 181.297c.02.468-.274 2.435-.346 3.657a62.572 62.572 0 00-.113 4.662c.006.39.064 1.17.064 1.17s-.468-.646-.548-1.025c-.133-.633.115-1.288.144-1.933.07-1.535-.21-3.1.077-4.609.128-.672.722-1.922.722-1.922z",
    display: "inline"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M122.84 188.732s.144 1.851.241 2.774c.11 1.046.287 2.084.388 3.13.079.818.17 2.458.17 2.458s-.406-1.112-.555-1.684c-.18-.69-.322-1.39-.412-2.098-.096-.752-.163-1.513-.136-2.27.027-.776.303-2.31.303-2.31z",
    display: "inline"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M126.145 199.062c-.059.217.173 1.66.167 2.492-.005.609-.097 1.213-.15 1.82-.06.687-.192 2.063-.192 2.063s-.2-1.438-.202-2.162c-.001-.53.093-1.054.14-1.58l.237-2.633z",
    display: "inline"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M132.56 173.395l-4.425 3.772-2.614 2.924-2.155 1.852-2.153 2.624-2.654 4.172-2.8 4.892-2.818 3.28-1.501 1.66-6.812-4.692 2.473-2.747 2.26-2.474 1.627-2.035 1.15-1.556 1.523-2.174 1.767-2.478 2.38-2.818 1.056-.886c5.015-.514 8.968-.985 13.696-3.316z",
    display: "inline"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M96.39 174.331s1.024 1.165 1.608 1.672c.747.647 1.593 1.172 2.407 1.733 1.333.918 2.588 1.989 4.057 2.668 1.208.558 2.519.906 3.832 1.118 1.255.202 2.539.118 3.809.136 1.017.014 2.035-.015 3.053-.026.396-.004 1.187-.015 1.187-.015s-1.418-.204-2.133-.246c-1.068-.063-2.142.045-3.211-.01-1.185-.06-2.388-.07-3.541-.35-.891-.214-1.723-.63-2.559-1.008-.902-.407-1.803-.831-2.645-1.353-1.137-.705-2.15-1.592-3.227-2.386-.878-.646-2.636-1.933-2.636-1.933z",
    display: "inline"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M100.38 189.015s1.282-.045 1.907.07c1.032.187 2.012.602 2.981 1 .66.27 1.92.94 1.92.94s-.836-.142-1.235-.28c-.461-.159-.869-.447-1.322-.627a18.876 18.876 0 00-2.603-.85c-.54-.129-1.648-.253-1.648-.253z",
    display: "inline"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M110.078 188.172s-1.41.268-2.096.471c-.411.122-.795.325-1.206.447-.724.214-1.503.232-2.21.496-.162.06-.457.247-.457.247s1.093-.14 1.635-.242c.621-.117 1.245-.233 1.848-.422.852-.266 2.486-.997 2.486-.997z",
    display: "inline"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M110.623 187.01c-.158.032-1.807.631-2.748.766-.638.09-1.29-.004-1.933.022-.78.033-1.555.196-2.334.168-.894-.032-1.776-.214-2.654-.382-.45-.086-1.337-.32-1.337-.32s.53.378.832.487c.794.287 1.658.332 2.497.413.462.044.928.036 1.392.039.686.004 1.371-.003 2.056-.035.5-.023 1.01-.003 1.499-.113.95-.213 2.73-1.046 2.73-1.046z",
    display: "inline"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M104.999 204.287c-.41.64-.385 2.786-.387 3.465-.022-.547-.086-3.207.387-3.465z",
    display: "inline"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M104.536 204.201c-.683.807-.22 2.214-.303 3.31.087-1.093-.185-2.349.303-3.31z",
    display: "inline"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M104.015 204.03c-.44.942-.295 2.142-.417 3.173.123-1.032-.207-2.437.417-3.173z",
    display: "inline"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M103.567 203.706c-.634.47-.292 2.22-.432 3.338.147-1.115-.03-2.798.432-3.338z",
    display: "inline"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M103.084 203.358c-.64.451-.37 2.295-.522 3.397.152-1.104.036-2.843.522-3.397z",
    display: "inline"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M102.572 203.003c-.452.943-.305 2.348-.455 3.524.149-1.178-.097-2.831.455-3.524z",
    display: "inline"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M102.068 202.808c-.712 1.21-.355 2.385-.505 3.505.15-1.12-.022-2.568.505-3.505z",
    display: "inline"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M101.611 202.52c-.688 1.086-.256 2.298-.368 3.385.11-1.086-.222-2.247.368-3.386z",
    display: "inline"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M104.586 200.969c-.078.381-.13.782.552 1.757-.34-.643-.64-1.271-.552-1.757z",
    display: "inline"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M103.92 200.95a6.202 6.202 0 00.27 1.912c-.303-.567-.39-1.205-.27-1.912z",
    display: "inline"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M103.347 200.672c-.11.485-.15 1.012.08 1.701-.141-.535-.155-1.106-.08-1.701z",
    display: "inline"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M102.999 200.292c-.182.532-.285 1.116-.052 1.738-.155-.514-.07-1.146.052-1.738z",
    display: "inline"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M102.575 200.15c-.18.27-.277.568-.28.894.012-.271.157-.586.28-.894z",
    display: "inline"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M102.286 199.866c-.13.13-.273.175-.376.477.191-.065.278-.273.376-.477z",
    display: "inline"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M101.831 199.468c-.117.164-.214.332-.415.475.109-.214.267-.335.415-.475z",
    display: "inline"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M101.535 199.171a1.466 1.466 0 00-.49.6c.042-.3.157-.539.49-.6z",
    display: "inline"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M104.169 194.837l6.751 5.397-5.37 3.497-.149-.816-.712-1.638-2.91-1.842-.5-.338-.06.095-.398 1.073.79 2.317-.502 3.079-1.486-1.991-1.647-3.703-1.857-3.348-.802-1.635-1.158-1.384-.381-.456-.688-1.25-.57-1.034-.27-2.895 1.02-.41.592 3.432 4.96.472 2.663 1.256 2.385.999.35.195z",
    display: "inline"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M106.58 208.974s.533.84.914 1.146c.38.306 1.314.648 1.314.648s-.997-.11-1.377-.4c-.432-.33-.85-1.394-.85-1.394z",
    display: "inline"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M106.943 207.502c.17 1.111.707 2.037 1.401 2.784-.492-.973-.97-1.902-1.401-2.784z",
    display: "inline"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M109.01 202.633l.545 1.91 1.511 1.884.116 1.534-1.026-1.052.833 1.598-.194 1.14-2.658-1.927 1.39 1.905-2.03-1.916-2.623.045-.36.04.261-.704.096-1.487.23-1.096.764-1.792-.21-1.29 2.415.638z",
    display: "inline"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M101.045 202.356l3.965 2.394.658-1.26c-1.132-.513-2.304-.627-3.102-1.44-.354-.361-.3-.99-.612-1.389-.2-.253-.77-.589-.77-.589l-.753-.264z",
    display: "inline"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M98.86 190.98c-1.893.03-3.659-.105-5.464-.275 1.816.082 3.604.074 5.463.275z",
    display: "inline"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M98.656 190.532c-1.755.084-3.461.054-5.153-.012 1.679-.083 3.365-.151 5.153.012z",
    display: "inline"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M98.456 190.001c-1.737.099-3.472.14-5.144.036 1.711-.129 3.422-.038 5.144-.036z",
    display: "inline"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M98.404 189.46c-1.646.167-3.225.084-4.806.007 1.63-.082 3.23-.081 4.806-.008z",
    display: "inline"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M98.245 188.85a39.168 39.168 0 01-4.727.09c1.58-.099 3.157-.139 4.727-.09z",
    display: "inline"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M98.048 188.28c-1.577.12-3.123.15-4.654.134 1.56-.141 3.115-.222 4.654-.134z",
    display: "inline"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M97.914 187.664c-1.466.195-2.89.132-4.321.12 1.439-.05 2.878-.095 4.32-.12z",
    display: "inline"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M92.197 169.513c.66.85 1.797 1.429 2.086 2.465.317 1.131-.678 2.312-.552 3.48.085.787.525 1.497.863 2.212.58 1.232 1.336 2.374 1.992 3.567.662 1.204 1.269 2.44 1.963 3.626.35.599.883 1.104 1.11 1.76.267.768.3 1.615.254 2.427-.05.861-.561 2.526-.561 2.526s-.602-1.72-.978-2.55c-.232-.51-.786-1.486-.786-1.486l-4.27.181-1.068.244-1.365-1.615-2.776-1.127-1.723-2.13-1.139-1.377-.749 1.196-2.928-2.723-3.192-2.913-2.632-3.898-3.197-5.894-4.782-6.354s5.132 3.15 7.982 4.013c.533.162 1.118.342 1.658.205.625-.159 1.128-.66 1.575-1.125.373-.388.886-1.351.886-1.351s-.042 1.292.132 1.904c.11.388.238.834.565 1.07.262.19.673.318.958.164.488-.265.349-1.07.66-1.53.388-.574 1.466-1.477 1.466-1.477l-1.572 2.493s.188 1.513.783 1.679c1.02.283 2.635-1.77 2.635-1.77s-1.564 1.747-2.028 2.802c-.548 1.248-.88 2.645-.818 4.006.042.94-.095 2.452.812 2.703.705.196 1.232-.857 1.624-1.474 1.198-1.887 1.964-6.413 1.964-6.413l-1.45 8.192-.154 2.892-.264 2.24 1.284-1.417 1.032 1.788 1.656 2.377 3.68 2.847s-.293-2.395-1.067-3.22c-.372-.397-1.204-.164-1.513-.611-.278-.4-.057-.974-.037-1.46.036-.865.469-1.736.28-2.58-.125-.563-.816-.907-.9-1.478-.074-.496.306-.96.375-1.456.128-.92.064-1.855.068-2.783.006-1.272-.164-2.547-.06-3.814.047-.58.309-1.716.309-1.716s1.235 1.816 1.909 2.683z",
    display: "inline"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M99.749 187.303c.953 2.07 1.432 4.517 3.058 6.068-1.431-1.82-2.091-4.028-3.058-6.068z",
    display: "inline"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M99.68 189.382c.281 1.35.96 2.568 1.678 3.622-.68-1.105-1.3-2.361-1.677-3.622z",
    display: "inline"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M89.422 179.615s-.06 1.591-.233 2.364c-.184.822-.252 1.783-.845 2.381-.22.222-.879.322-.879.322s.706-1.505 1.008-2.278c.357-.915.95-2.789.95-2.789z",
    display: "inline"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M89.826 173.478c-.12.044-1.81.655-2.394 1.364-.207.25-.31.923-.31.923s.914-.4 1.3-.706c.552-.438 1.404-1.581 1.404-1.581z",
    display: "inline"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M89.464 179.571c.473.514-.169 1.387-.275 2.078-.064.418.058.931-.22 1.251-.155.18-.499.38-.675.222-.395-.353.2-1.04.324-1.556.161-.665.01-1.553.544-1.98.079-.064.234-.089.302-.015z",
    display: "inline"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M89.195 164.361c-.325.43-.452.984-.604 1.502-.295 1.005-.588 3.085-.588 3.085s.436-.565.592-.884c.21-.428.318-.9.454-1.358.275-.923.729-2.795.729-2.795s-.435.254-.583.45z",
    display: "inline"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M89.186 161.343c-1.063 2.151-2.826 3.647-4.298 5.175 1.416-1.54 2.961-3.357 4.298-5.175z",
    display: "inline"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M88.603 160.215c-1.731 1.95-3.231 4.084-5.623 5.946 1.829-1.81 3.727-3.976 5.623-5.946z",
    display: "inline"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M86.76 158.644l-.885 1.667-.639 1.05-.407.705.838.026 1.404-1.696.935-1.317-.589-1.184z",
    display: "inline"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M83.84 162.454l-1.472 1.652-.563 1.438.29.74.898-1 1.164-1.435 1.005-.823-.993-.052z",
    display: "inline"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M85.471 155.54c0 .117-.496 2.732-.496 2.732l-.591 1.264-1.288 1.486-.95 1.234-.642 2.164-.491 1.286.127-1.37.569-2.087.84-1.253.677-1.507.004-.47-.35-.273-.892.574-1.233 1.949-.618 1.843-.398 1.078.573-2.421.827-2.754.62-1.497-.317-1.029-.36-.147.743-.797.83-.869.22-1.41.173-1.144-.245-.733-.634.186-.015-1.867.083-.84.086.168.548 1.269 2.157 4.129.693.883z",
    display: "inline"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M80.91 156.175s-.366.763-.513 1.159c-.208.557-.37 1.13-.525 1.705-.119.44-.321.877-.312 1.334.007.31.19.59.25.894.086.451.15 1.369.15 1.369s.06-1.212.119-1.816c.06-.632.104-1.268.24-1.888.115-.521.378-1.003.482-1.526.08-.404.108-1.23.108-1.23z",
    display: "inline"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M75.301 160.467c.444.826.094 1.89.352 2.793.178.624.815 1.77.815 1.77s-1.452-.712-2.067-1.226c-.586-.49-.988-1.166-1.499-1.734-.492-.548-.951-1.133-1.508-1.615a16.518 16.518 0 00-2.917-2.029c-.507-.275-1.1-.936-1.602-.653-.334.188-.18 1.136-.18 1.136l-.741-1.686-.786-1.884-2.164-3.027-5.034-5.09-1.878-3.233 3.732-5.76c1.87-.82 4.024-1.251 5.345-2.82l1.987.003 1.803-.672 2.674-1.127c.402.316.915.012 1.434-.327l-1.088-.277c.477-.52 1.197-.544 1.86-.683l1.128-.963c-.446 3.36-5.288 8.27-8.929 12.756l.873 1.616s-3.321-.05-3.457 1.156c-.065.586.967.693 1.51.919.608.252 1.26.46 1.918.47 1.576.021 4.621-1 4.621-1l-1.909.948s-1.106.342-1.609.62c-.532.295-1.073.626-1.46 1.095-.165.2-.312.44-.339.698-.016.158.054.317.118.463.092.21.162.498.378.574.457.161.906-.534 1.383-.446.46.085.726.59 1.096.878.457.356 1.15.52 1.386 1.05.102.227.045.52-.062.746-.187.397-.787.506-.943.916-.078.207-.077.481.05.662.453.642 1.677.334 2.152.959.12.157.017.4.087.584.117.303.332.562.54.811.287.347.636.64.969.944.636.582 1.553.925 1.961 1.684z",
    display: "inline"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M79.124 143.738s-.282.65-.442.965c-.318.623-.596 1.28-1.03 1.828-.238.301-.544.544-.845.783-.543.43-1.13.804-1.723 1.163-.68.411-1.393.763-2.096 1.132-.842.442-1.66.936-2.541 1.295-.68.277-2.1.656-2.1.656s1.564-.215 2.296-.492c.992-.375 1.842-1.05 2.772-1.56.66-.36 1.348-.67 1.99-1.06.521-.317 1.046-.638 1.506-1.037.484-.42.96-.87 1.302-1.411.434-.687.911-2.262.911-2.262z",
    display: "inline"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M79.67 143.816s-.396.986-.622 1.466c-.246.526-.454 1.081-.8 1.548-.29.39-.664.714-1.044 1.016-.522.414-1.112.736-1.683 1.078-.66.395-1.329.777-2.017 1.122-.482.242-.975.465-1.477.662a16.9 16.9 0 01-1.425.481c-.375.11-1.136.282-1.136.282s1.688-.302 2.498-.576c.627-.214 1.213-.536 1.81-.826.574-.28 1.154-.554 1.702-.884a16.098 16.098 0 001.732-1.202c.384-.308.776-.618 1.09-.998.24-.291.43-.625.592-.966.336-.703.78-2.203.78-2.203z",
    display: "inline"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M78.83 143.21s-.725.927-1.113 1.369c-.491.56-.966 1.143-1.536 1.622-.546.458-1.182.795-1.782 1.18-.66.426-1.313.866-2 1.248-.567.315-1.157.59-1.747.86-.49.226-.988.437-1.49.635-.358.142-1.085.395-1.085.395s1.323-.213 1.963-.407c.73-.221 1.437-.519 2.12-.858.61-.303 1.168-.701 1.755-1.048.68-.402 1.43-.7 2.045-1.196.595-.483 1.084-1.09 1.549-1.7.5-.658 1.322-2.1 1.322-2.1z",
    display: "inline"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M74.864 149.629s.326.57.608.687c.48.2 1.042-.005 1.554-.087.399-.064.787-.187 1.17-.314a21.169 21.169 0 001.216-.483s-.883.115-1.327.14c-.671.039-1.347.075-2.017.019-.29-.024-.574-.201-.862-.153-.129.022-.342.191-.342.191z",
    display: "inline"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M81.295 145.459c-.187.013-.461-.086-.56.075-.116.19.036.51.222.632.102.067.263-.093.364-.025.172.116-.005.533.194.592.103.03.196-.108.25-.2a.569.569 0 00.06-.342c-.027-.262-.073-.587-.291-.734-.066-.045-.16-.004-.239.002z",
    display: "inline"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M71.993 150.528s.358.454.542.679c.207.254.631.754.631.754s-.513-.186-.706-.369c-.12-.114-.184-.28-.254-.43a6.078 6.078 0 01-.213-.634z",
    display: "inline"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M72.603 147.221c-1.35.923-2.642 1.905-4.267 2.554 1.97-.374 3.063-1.511 4.267-2.554z",
    display: "inline"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M79.537 138.308c-.7.273-1.083 1.04-1.609 1.575-.638.651-1.283 1.298-1.875 1.992-.406.476-.794.97-1.148 1.488a18.147 18.147 0 00-1.028 1.7c-.179.335-.482 1.03-.482 1.03s.91-.957 1.355-1.445c.572-.626 1.105-1.287 1.69-1.9.474-.496 1.013-.927 1.473-1.435.48-.531.853-1.156 1.341-1.681.24-.257.624-.398.773-.716.084-.179.166-.447.033-.592-.118-.129-.36-.08-.523-.016z",
    display: "inline"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M79.904 139.524c-.383.103-.42.702-.46 1.096-.012.114.094.227.067.339-.078.33-.467.502-.624.802-.145.276-.281.892-.281.892s.69-.343.853-.665c.102-.2-.052-.461.022-.674.076-.221.32-.353.417-.567.083-.185.073-.4.13-.595.041-.142.194-.276.152-.418-.032-.111-.165-.24-.276-.21z",
    display: "inline"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M80.138 136.653c-.074.786-1.06 1.173-1.637 1.713-.581.546-1.268.975-1.832 1.54-.46.461-.86.981-1.258 1.5-.338.44-.644.906-.956 1.367-.323.476-.59.99-.946 1.443a8.758 8.758 0 01-1.066 1.138c-.425.377-.89.708-1.372 1.007-.406.252-1.273.659-1.273.659s.796-.952 1.215-1.409c.4-.435.828-.843 1.238-1.269.478-.497.975-.979 1.424-1.502.338-.393.65-.81.955-1.228.29-.399.55-.82.836-1.22.324-.455.674-.89.998-1.344.276-.388.483-.83.806-1.18.234-.255.546-.424.806-.652.33-.29.59-.664.953-.911.207-.14.44-.384.68-.315.253.073.454.401.43.663z",
    display: "inline"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M78.841 129.393s-.098 1.514-.361 2.215c-.113.3-.372.528-.509.82-.354.752-.5 1.588-.795 2.366-.194.51-.42 1.006-.64 1.504-.249.563-.455 1.149-.768 1.678-.281.476-.677.875-.99 1.33-.39.569-.717 1.179-1.103 1.75-.481.71-.974 1.414-1.511 2.082-.504.626-1.02 1.247-1.603 1.8-.49.468-1.079.822-1.584 1.273-.373.334-1.065 1.059-1.065 1.059s.084-1.222.24-1.81c.117-.44.236-.905.516-1.263.237-.304.614-.465.932-.683.306-.21.638-.382.936-.604.5-.373.958-.799 1.418-1.219.35-.32.689-.652 1.023-.989.358-.36.696-.738 1.051-1.1.232-.236.461-.475.704-.699.18-.165.408-.282.559-.475.146-.189.206-.43.315-.643.162-.312.36-.606.504-.926.13-.29.216-.597.325-.895.084-.232.167-.465.253-.696.154-.416.317-.828.469-1.245.137-.378.287-.753.4-1.139.107-.37.097-.776.262-1.124.049-.104.191-.16.21-.273.016-.1-.097-.186-.1-.288-.011-.3.102-.6.232-.87.165-.348.68-.936.68-.936z",
    display: "inline"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M76.948 128.407s.11 1.023.119 1.537c.008.474-.011.95-.06 1.421-.03.285.146.826-.14.848-.266.02-.218-.496-.248-.76-.047-.417.07-.836.113-1.252.063-.6.216-1.794.216-1.794z",
    display: "inline"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M76.561 132.943c-.01.108-.049.762-.049.762l-.346.206.01-.673z",
    display: "inline"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M75.562 135.743l.144.577-.46.06.26-.722z",
    display: "inline"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M76.015 136.79s-.65.415-.949.276c-.17-.08-.226-.515-.226-.515s-.249.575-.124.822c.1.197.37.354.587.31.373-.079.712-.892.712-.892z",
    display: "inline"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M71.875 139.855c.16-.005.14.308.278.387.314.181 1.083.104 1.083.104s-.222.364-.408.436c-.297.116-.647.018-.952-.071-.082-.024-.18-.05-.225-.12-.062-.095-.05-.23-.023-.339.038-.151.091-.392.247-.397z",
    display: "inline"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M70.186 142.434l-.685-.007-.3-.359-.482-.131-.302.34.483.27.679.138z",
    display: "inline"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M69.27 143.595l-.817-.508-.226-.188-.005.614.642.453z",
    display: "inline"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M76.253 130.07l-.026.41-.308.261.282.54-.208.158.034.568-.45.345.418.468-.59.18.31.529-.538.313.013.55-.51.357-.025.583.245.39-.41-.08-.27.056-.128.4.442.248-.048.29-.489-.27-.293.138.203.67h-.56l-.063.61-.445-.057.072.485-.558-.014s.033.698.01.586c-.023-.113-.57.127-.57.127l.063.526-.569.02-.092.628-.578.37-1.481 1.024-2.166 1.176 2.62-3.227.541.192.16-.346.6-.228-.067-.426.703-.087-.076-.618.661.017-.081-.463.7-.226-.138-.491.749-.243-.254-.49.76-.106-.263-.515.717-.228.086-.37-.4-.117.643-.202-.053-.55.325-.164.124-.534.232-.326-.101-.426.541-.404-.177-.413.388-.339-.188-.56.276-.319z",
    display: "inline"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M79.208 123.293l-.526.153.11.457z",
    display: "inline"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M78.577 124.561l-1.178.801.705.001.227.295.199-1.018z",
    display: "inline"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M77.642 126.716l-.706 1.121-.848 1.214-.548.898.785-.627.863-1.095z",
    display: "inline"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M74.736 116.577c-.068.577-2.91 2.894-2.91 2.894l-1.67 2.467-2.027 2.947-1.766 3.519-2.084 2.817-1.606 1.474-1.57 2.246-.322 1.424 1.233-1.402 2.062-2.275c.4.359.93.345 1.492.245l.948-.256-2.397-.171 1.028-.988c.323.201.342.728 1.173.386.466.168 1.139-.313 1.829-.85l-1.406.129-1.165-.145.768-1.19c.862-.197 1.544.135 2.325.06-.94.46-1.748.408-2.381-.313l.544-.624 2.457-.128c.654.048 1.307-.73 1.96-1.278-.596.13-1.267.696-1.774.308l-1.669.247c.851-.308 1.62-1.37 2.415-2.197-.762.658-1.515 1.45-2.337 1.172l.673-1.217.91-1.51 1.05-1.663 1.117-1.27 1.265-2.04 1.79-1.786.674-.64z",
    display: "inline"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M80.9 120.267l-.472.12-.023-.93-.29.068.146.616-.675.375-.177.561.514.008.15-.061.366-.277z",
    display: "inline"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M76.94 118.157c-.054.096-1.933 1.04-1.933 1.04l-.723-.004-1.441 1.599 1.138-.706z",
    display: "inline"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M78.199 109.741l-1.604 2.246-.908 1.205-.925 1.278.871-.273.997-1.123z",
    display: "inline"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M79.37 114.62l-.473 1.528-.908.32-.44.43-.057.335.63.1.832-.447-.549.618-1.113.061-.22.778-.461-.26.418-.827.307-.9 1.052-.846.43-.437z",
    display: "inline"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M56.092 143.989l.437-3.71 2.111-8.334-1.97-3.81-3.494.156-5.06 1.595-1.736-.241.623-.648-.002-.34 1.176-.553-.642.803 1.106-.188.68-.434 1.263-1 .926-1.37.885-1.739 1.23-2.367.119.488-1.927 3.554-1.63 2.422-.27.672.734-.297.956-.317.918-1.239 1.348-1.458 1.035-1.631.473-1.04.364-.553.72-.475.417-.995.017-.652-.255-.284.176-.875.615-.149.094-.212.812-.014-.426 1.242-.7 1.042-.494 1.237-.46.322-.46.138-.286.447-.088.6.599-.157.749-.482.62.33.796.26 1.16-.28.574-.823-.425-1.352-.158-.265.208-.75 1.038 1.327 2.868-.047.585 1.09.335 1.519.215 1.419-.443 2.722-.496 1.22-.514 1.715-.523 1.577-1.44 1.383-1.497 1.002-1.092.952.053 1.366 1.547 1.873-.005 4.246z",
    display: "inline"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M58.357 98.106l.86 1.004.677 1.594.669 1.248.396 1.521.479 1.908.222 2.671-.043 1.327.106 1.517-.26 2.026-.139 1.567-.536 2.298-.963 2.196-1.065 1.593-1.774 2.389-.452.701.81-.868.787-1.196 1.04-1.258.971-1.645.742-1.47.34-1.56.359-2.479.201-2.397-.046-1.716.008-1.697-.157-1.572-.194-1.564-.393-1.165-1.087-2.77-.624-.947z",
    display: "inline"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M61.887 111.417c.81-.017 1.343.89 1.983 1.442-.72-.414-1.797-.43-1.983-1.442z",
    display: "inline"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M61.493 113.511c.755.902 1.492 1.777 2.363 2.858-.17-1.422-1.241-2.159-2.363-2.858z",
    display: "inline"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M60.201 118.569c.437.208.814.48 1.034.925z",
    display: "inline"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M61.29 115.087l.67.238-.639.058z",
    display: "inline"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M60.989 116.526l.841.501-.847-.16z",
    display: "inline"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M60.583 117.551l.748.47-.85-.189z",
    display: "inline"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M59.963 118.975l.35.464-.567-.173z",
    display: "inline"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M61.964 110.387l.714.17-.751.071z",
    display: "inline"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M61.449 114.211l.415.338-.45.06z",
    display: "inline"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M61.79 112.352l.401.206-.553.147z",
    display: "inline"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M59.56 119.593l.39.293-.665-.061.22-.14z",
    display: "inline"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M58.98 120.505l.617.258-.816.008z",
    display: "inline"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M58.214 121.364l.966.332-1.159-.067z",
    display: "inline"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M57.892 122.067l.58.357-.777-.23z",
    display: "inline"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M57.368 122.486l.903.397-.784-.536z",
    display: "inline"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M57.788 123.163l-.675-.088.227-.275.346.301z",
    display: "inline"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M59.5 111.155l.167.671-.297.901-.16 1.93-.148 1.797-.392 1.49-.294.565.328-2.239.151-1.555.227-1.902.27-.882-.212-.601z",
    display: "inline"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M54.01 115.928l.29.344.222.932-.223 1.715-.013.879-.207 1.161-.248.569-.144-.901.18-.714.042-.557.15-1.14.064-1.174-.348-.664z",
    display: "inline"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M51.662 118.63c-.023.133-1.089 1.449-1.089 1.449l-1.097.369.921.302.76-.75.715-.975z",
    display: "inline"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M50.563 122.502l-.504-.463-.732.237.32.429.713.32.828.463.543-.268-.823-.103z",
    display: "inline"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M48.465 122.57c-.147.15-.427.938-.427.938l-.316.84.24.555.35-.868z",
    display: "inline"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M47.806 125.392l-.54.546-.163.849.571-.047.12-.75-.033-.513z",
    display: "inline"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M48.795 120.56l-.014 1.194-.056.73-.114-.9z",
    display: "inline"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M46.923 109.346l1.472 1.372 1.439.054.352-.137.96.51.932-.142 1.546-.28 1.244-.957.94-1.038.896-1.22.363-1.219.2-1.036-.692 1.837-1.196 2.056-1.723 1.062-3.407.047-1.174-.5-1.01-.206-1.171-.742z",
    display: "inline"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M55.851 107.775l-1.593 1.137-2.03.095-.985.02-.265-.099-3.042.105-.928-.234.811.483.563-.031.958.314 1.106.357 1.634.022 1.437.048 1.456-.935z",
    display: "inline"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M42.895 93.431l.056.807.996 1.035 1.327 1.073.784.482.418.787.423 1.262.766 1.173-.69-.294-.12-.447-.726-1.097-.278-.768-.463-.652-1.484-.993-1.16-1.073-.449-.47z",
    display: "inline"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M47.754 100.455l.506.758.856 1 1.63.826 1.117.304-.139.676-1.55-.26-1.343-.586-.882-.889-.414-1.353-.194-.496-.091-.18z",
    display: "inline"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M64.064 107.951l-2.255 1.363-2.244 1.681-2.308 2.437-2.406 1.999-3.054 2.85-2.79 1.942-3.112 1.32-1.75.743-1.711 1.18-1.937 1.437.52-.58 2.092-1.501 1.697-.993 3.063-1.441 1.844-.584 1.467-1.346 2.065-1.65 1.29-1.42 1.846-1.569 1.752-1.492 1.098-1.2 1.4-1.106 1.062-.865z",
    display: "inline"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M66.456 121.796l-.516 1.149-1.577.562-.127.515.587-.062.707-.407 1.054-1.233z",
    display: "inline"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M67.37 120.275l-.13-3.73 1.02-3.246-1.04.367-1.248 2.219.161 3.018z",
    display: "inline"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M67.105 125.133l-.864-.025-.666-.4-.033 2.092-.612 1.572 1.272-.924.792-1.725z",
    display: "inline"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M70.778 108.982l-.82 4.71-.419-3.026z",
    display: "inline"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M67.973 108.43l-.324 2.309.249 2.004z",
    display: "inline"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M65.864 107.541l-.683 3.893-.808 2.59.654-4.917z",
    display: "inline"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M72.596 110.444l-1.066 4.586 2.118-.16-2.61.821z",
    display: "inline"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M70.585 117.268c-.108 1.476-.899 2.442-1.883 3.265z",
    display: "inline"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M37.363 123.043l1.845 1.037.429.684.23.51.693.401.085.42.06.704.132.805-.084.291-.175-.706-.87.04-1.095.307-.432.022-.365-.632.183-1.045.591-.645.873.246.499.251.667.111-.775-.399-.3-.486-.157-.292-.558-.213-.686-.393-.726-.434z",
    display: "inline"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M38.839 130.297l-.94-.28-.774-.44-.688-.392-1.034-.061-.371-.409-.333-.887-.493-1.293-.367-1.28-.352-.418-.09 2.5.108 1.039.503.531.49.592.312.29.647.365.227.435 2.716.223z",
    display: "inline"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M30.68 107.904l.498.049.476.632.358.983.284 1.032.089 1.465.328.151-.055.5-.003.684.014.682-.73 1.05.245-.454.215-.487-.108-.482-.223-.165.12-.449.172-.342-.167-.243-.284-.495-.496-.844-.02-.532.552-.422-.148-.9-.238-.503-.275-.488z",
    display: "inline"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M32 114.99l.015-.866-1.71-.169-1.745.172-1.673.054-.609-.314-.43-.84-.16-1.33.2-.668-1.175 1.337-.034 1.19.273.956 1.324.596 1.873.199 1.511-.068z",
    display: "inline"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M24.554 95.606l.29.748.414 1.405.327 1.579.314 1.908-.144.435-1.42.393-.538.077.54-.746.5-1.593.275-1.232-.073-.67-.9-.868-.587-.566.405-.588z",
    display: "inline"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M24.635 101.968l-.05-.968-.748.28-.972.704-1.19.143-1.23-.227-1.37-.409-1.53-.618-.767-.697.772 1.279 2.028.895 2.014.215z",
    display: "inline"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M22.094 90.023l-.025 1.051.02 1.713.297 1.882.146.915-.996.337-.584.01.113-1.247.185-1.498.28-1.097.275-1.05z",
    display: "inline"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M19.438 96.193l-2.581-.173.68-.876.002-.987.786.375.356.848z",
    display: "inline"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M21.831 98.354l1.001 1.161.63 1.67.223.714-1.207.374-.137-1.163-.217-1.239z",
    display: "inline"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M59.832 107.496c-1.245.094-2.126.755-2.919 1.552z",
    display: "inline"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M58.32 110.698c-.754.874-1.478 1.787-2.602 2.186z",
    display: "inline"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M44.514 122.272l.239 1.52-.447 1.678-.136-1.421.3-1.63z",
    display: "inline"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M43.953 123.836l-1.858 3.502c.484-1.039.91-2.043 1.695-3.261z",
    display: "inline"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M38.363 105.266s1.432.447 2 .909c1.099.894 2.098 2.075 2.507 3.431.413 1.369-.193 4.284-.193 4.284s.512-2.842.098-4.17c-.373-1.194-1.295-2.178-2.205-3.038-.636-.6-2.207-1.416-2.207-1.416z",
    display: "inline"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M40.085 110.126c.41.178.875.323 1.162.665.224.265.277.64.354.98.139.605.214 1.232.192 1.853-.012.327.056.73-.17.967-.232.244-.985.22-.985.22s.31-.826.325-1.26c.02-.57-.046-1.177-.31-1.684-.226-.436-.75-.65-1.031-1.052-.206-.295-.695-.704-.46-.975.212-.243.628.158.923.286z",
    display: "inline"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M36.497 105.834l1.647.138 1.451.756-.21.65.895.186-1.05-.261-.984-.713z",
    display: "inline"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M34.31 106.388s.735.218 1.026.45c.348.28.523.722.793 1.076.201.265.447.498.616.785.272.46.392.997.626 1.479.093.19.378.357.308.558-.05.145-.286.24-.428.177-.474-.207-.336-.98-.537-1.456-.096-.228-.22-.444-.32-.67-.155-.35-.209-.755-.437-1.062-.422-.567-1.647-1.337-1.647-1.337z",
    display: "inline"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M32.261 106.829l1 .254s.433.393.59.635c.345.528.544 1.141.748 1.739.156.458.23.94.36 1.406.158.565.333 1.125.51 1.685.203.647.625 1.255.633 1.933.004.368-.32 1.056-.32 1.056l-.245-.289s.014-.446-.007-.668a4.661 4.661 0 00-.168-.967c-.086-.273-.263-.51-.361-.778-.154-.423-.243-.867-.354-1.303-.134-.527-.281-1.051-.377-1.586-.064-.36-.014-.741-.132-1.086-.082-.239-.231-.452-.388-.65-.251-.316-.575-.57-.873-.843-.2-.185-.616-.538-.616-.538z",
    display: "inline"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M36.828 96.306s1.078-.164 1.514.092c.322.188.446.603.604.94.416.89.698 1.847.883 2.812.095.497.096 1.009.113 1.515.027.827-.02 2.482-.02 2.482l-.324.02s.166-.7.18-1.058c.032-.783-.135-1.563-.211-2.343-.06-.622-.061-1.255-.196-1.865-.099-.447-.183-.925-.446-1.3-.178-.256-.465-.42-.726-.59-.43-.28-1.371-.705-1.371-.705z",
    display: "inline"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M35.317 96.113s.616.372.854.635a6.114 6.114 0 011.158 1.93c.156.413.23.86.243 1.302.015.52-.146 1.03-.198 1.548-.07.696-.069 1.398-.153 2.092-.043.347-.177 1.035-.177 1.035s-.172-.371-.195-.57c-.034-.314.05-.63.103-.94.08-.483.274-.944.329-1.43.06-.548-.03-1.103-.006-1.653.013-.27.153-.547.076-.805-.067-.228-.324-.352-.44-.559-.164-.29-.2-.64-.35-.936-.142-.276-.33-.526-.515-.775-.227-.304-.73-.874-.73-.874z",
    display: "inline"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M34.41 96.28s.655.958.767 1.512c.062.308-.082.627-.067.942.026.536.242 1.052.268 1.589.035.718-.057 1.439-.153 2.151a16.79 16.79 0 01-.222 1.107l-.358-.128s.094-1.43.122-2.147c.04-1.018-.39-2.143.065-3.054.037-.074.169-.076.195-.154a.337.337 0 00-.086-.33c-.064-.06-.194.017-.256-.044-.35-.343-.275-1.445-.275-1.445z",
    display: "inline"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M32.642 95.365c.574.286 1.265.669 1.246 1.173-.494-.507-.863-.83-1.246-1.173z",
    display: "inline"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M30.255 95.174l-.006.86.71.454.767 1.26.281 1.474.32 2.207-.185 1.101-.526.142.304-1.392-.38-2.38-.048-.868-.688-.682-.766-.52-.109-.415-.007-1.013-.085-.342z",
    display: "inline"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M27.424 94.803l-.125 1.513.904.866.405 1.58.389 1.121.33 2.281-.42-.5-.071-1.01-.267-1.222-.546-1.578-.391-.484-.563-.614-.29-.27.195-.722z",
    display: "inline"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M33.646 93.235c.145.9.36 1.75.142 2.905z",
    display: "inline"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M31.185 91.081l.394 3.991c.194-1.308.106-2.157-.177-3.416z",
    display: "inline"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M28.597 90.849c.309 1.387.476 2.621.142 4.01z",
    display: "inline"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.367,
    d: "M24.84 90.385c1.572 1.504 1.156 2.987 1.312 4.477-.165-1.488-.182-2.975-1.312-4.477z",
    display: "inline"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M158.928 116.422l1.643 1.277.921 1.02.772 1.311.703 1.217.746 1.512.29 1.232.065 1.877-.49 3.44-.969 3.411-.824 2.891-.667 2.793-.77 2.56-.809 2.505.217 1.889.547 1.742.575.885.327 1.295-.208.664.109.602.413.46.42 1.145.118 1.925-.116 2.348.33.322.031 2.206.21 1.036.336 1.114.247.91.135.777-.166.565-.294.471-.478.433-.27.354-.232.314-.25.509-.306.227-.486.302-.707.569-.691.592-.425.311-.61.243-.692-.361-1.033-.043-2.486.11-.508.542-.741.094-.773-.094-.375.22-.431-.452-1.06-.663-.929-.265-.132-.22-1.48-.277-.29-.446.09-.382-.441-.618-.575-.398-1.049.044-.177-.452-.541-.078-.022-.364-.773-.21-.089-.971-.795-.707-1.06-.707-.62-.883-.51-.41.16-1.248.306-.771.112-.843.463-.792.462-.499.598-.472.204-.48.651-.673.59-1.398 1.62-.076 1.07.088 1.087.1 1.225.157.917.54.142.282.78.074.36.107.144.243.193-.115-.227-.35-.536-.322-.19-.278-.383-.63-.026-.696.189-.95-.211-.635.238-.785.231-1.029.39-.491.473-.878.6-.708.372-.895.26-.98 1.529-1.322.833-1.116.708-1.015.823-1.178.602-1.978.558-1.926 1.61-5.688.2-6.762-.367-3.771z",
    display: "inline",
    opacity: 1
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M157.531 148.955c-1.125-1.088-4.362-.823-6.715 2.524 2.748-2.49 5.235-3.04 6.715-2.524z",
    display: "inline"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M160.191 137.578c-.835.356-1.695.386-2.451.267.722.649 1.57.505 2.451-.267z",
    display: "inline"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M161.097 124.152c.071 2.15.385 3.923 1.546 4.515-.74-1.281-1.108-2.933-1.546-4.515z",
    display: "inline"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M160.444 126.825c.413 1.164.935 2.163 1.664 2.852-1.127-.389-1.471-1.324-1.664-2.852z",
    display: "inline"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M162.195 131.896c-.082-.377-.049-.755-.23-1.157-.507-.292-1.077-.165-1.584-.24 1.521.006 1.75 1.067 1.814 1.397z",
    display: "inline"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M161.743 131.19c.238 1.32-.329 2.323-1.576 3.056 1.007-.991 1.55-2.009 1.576-3.056z",
    display: "inline"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M158.482 141.796c-.298.493-.528 2.255-2.288 2.08.863.003 1.577-1.477 2.288-2.08z",
    display: "inline"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M159.433 146.192c-.596-.896-1.589-1.91-3.12-2.183 1.02.41 2.26 1.3 3.12 2.183z",
    display: "inline"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M160.787 149.8c-.614-1.253-1.546-2.02-2.69-2.437 1 .588 1.968 1.241 2.69 2.436z",
    display: "inline"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M152.182 154.598c1.74-1.183 3.814-1.641 5.082-.148-1.202-.822-3.247-.69-5.082.148z",
    display: "inline"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M150.86 152.222c1.206-.533 2.497-2.163 3.64-1.515.449.254.57 1.148.223 1.53-.478.527-1.612 1.343-2.362 2.183 2.398-2.518 3.922-4.755-1.5-2.198z",
    display: "inline"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M151.291 148.294c.723-.447 1.646-.964 2.214-1.047.63.004.484.806.282 1.143-.425.71-1.833 1.6-2.703 2.65 4.136-4.29 2.604-3.804.207-2.746z",
    display: "inline"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M157.416 159.995s.656.534.92.861c.274.34.556.705.673 1.126.163.587.051 1.22.005 1.827-.04.527-.037 1.08-.243 1.568-.306.719-1.418 1.867-1.418 1.867s.894-1.292 1.087-2.037c.143-.557-.05-1.154.026-1.724.066-.5.55-.996.372-1.469-.16-.425-.868-.395-1.126-.77-.242-.352-.296-1.249-.296-1.249z",
    display: "inline"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M158.364 152.668s.6.867 1.07.95c.167.03.313-.241.475-.187.289.097.475.781.475.781z",
    display: "inline"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M159.077 158.074s-.16-.775-.475-.913c-.644-.28-2.26.399-1.997.725.22.274 1.017.363.952.629-.07.291-.911-.13-1.37-.133-.19-.001-.382.084-.57.048-.43-.084-1.176-.594-1.176-.594 3.228.981 3.101-1.385 4.636.238z",
    display: "inline"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M149.033 154.33c-.097 3.283.655 5.46-1.367 11.407.794-3.954 1.044-7.609 1.367-11.406z",
    display: "inline"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M147.13 154.39c.51 2.666-.222 3.677-.594 5.169.555-1.901.672-3.584.595-5.169z",
    display: "inline"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M144.705 157.625c.344.78.436 1.78.064 2.541-.15.305-.447 1.491-1.086 1.679-.259.076-.737-.334-.737-.334 1.412-1.485 1.724-1.99 1.759-3.886z",
    display: "inline"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M156.343 166.628c.928-2.404-.148-2.893-2.344-.222 1.653-.977 2.697-1.598 2.344.222z",
    display: "inline"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M152.668 155.626c.003.387-.09.725-.307 1.2.269.079.506.367 1.101.744-.486-.4-.921-.82-.921-.82.289-.399.74-.684 1.15-1-.42.296-.912.53-1.216.94.166-.106.21-.697.193-1.064z",
    display: "inline"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M154.415 158.475c.497.374 1.492 1.202 1.874 1.691-.495-.413-1.48-1.24-1.874-1.691z",
    display: "inline"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M146.233 153.82c.18.589.232 1.238.142 1.744.372-.604.354-1.304-.142-1.745z",
    display: "inline"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M145.22 153.336c.663.684.55 1.697.287 2.773.023-.945.15-1.909-.286-2.773z",
    display: "inline"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M142.351 158.573c.47 1.062.676 1.701.054 2.326.246-.796.048-1.557-.054-2.326z",
    display: "inline"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M162.814 128.855c-1.06 4.953-1.985 7.952-4.33 13.025 1.91-4.974 3.127-8.14 4.33-13.025z",
    display: "inline"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M163.615 126.497c-.67.579-.803 1.32-.886 2.49.182-1.283.529-1.734.886-2.49z",
    display: "inline"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M163.538 126.299s-.028-1.173-.128-1.748a12.949 12.949 0 00-.706-2.535 9.785 9.785 0 00-.947-1.812c-.557-.838-1.926-2.326-1.926-2.326s1.155 1.078 1.637 1.7c.4.517.731 1.086 1.027 1.668.186.366.333.751.465 1.14.208.608.418 1.224.514 1.86.102.677.064 2.053.064 2.053z",
    display: "inline"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M144.991 154.42c-.066 1.094-.14 2.15-1.218 3.238.778-1.206.942-2.244 1.218-3.238z",
    display: "inline"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M144.01 155.133a3.549 3.549 0 01-.772 1.96c.36-.602.566-1.28.772-1.96z",
    display: "inline"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M142.762 157.123c-.133.504-.232 1.016-.98 1.366.651-.617.787-.977.98-1.366z",
    display: "inline"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M142.851 155.638c.392.105.486.453.402.875-.079-.453-.207-.732-.402-.875z",
    display: "inline"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M153.017 167.024c-.829.237-2.177.486-2.572-.28-.462-.895 1.478-2.636 1.478-2.636s-1.15 1.313-1.049 2.084c.035.266.281.516.536.6.84.276 2.595-.546 2.595-.546s-.585.662-.988.778z",
    display: "inline"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M142.808 146.71l.427-.377.129-.774.113-.654.128-.94.187-.805.392-.93.558-1.297.23-.627.225-1.033.307-1.242.028-1.189.198-1.218-.242-.8-.356-1.158-.642-1.409-.566-1.074-.658-1.219-.516-.942-.526-.93-.496-.876-.622-1.183-.8-1.335-.802-1.142-.68-1.401-.763-1.285-.856-1.619-1.178-1.79-1.123-1.691-1.772-1.866-2.12-1.917-2.037-1.519-2.512-2.107-2.95-2.309-2.94-2.09-3.594-2.256-2.815-1.406-2.561-1.363-2.621-.79-2.564-.784-2.91-.648-4.285-.31-3.53.217-1.373-.204-1.638.019-1.015.366L94 94.91l2.35-1.729 2.962-1.807 2.693-1.417 2.97-1.297 2.333-.867 2.035-.145 2.473-.143 2.21-.34 2.74-.15 2.077-.087 2.517-.004 3.137.162 2.695.621 2.27.481 2.715.82 2.742 1.07 3.188 1.425 3.31 2.011 2.307 1.716 2.867 2.236 2.83 2.914 1.401 1.636.674.882 1.394 1.345 1.331 1.535 1.218 1.822 1.118 2.29 1.278 3.028 1.096 3.607.695 3.246.265 3.266v3.712l-.176 3.269-1.032 3.923-.892 2.9-.86 2.784-1.29 1.952-1.39 1.723-.526.533-.55.341-.329 1.216-.39.773-.535.753-.447.732-.501.586-.169.96-.284.853.202.664-.18.98.02.663.557.875.599.355.171.308-.184.115-.163-.222-.304-.128-.805-.032-.106-.287-.934-.57-3.349-.325-1.667.039-.672 1.528-.583.598-.23.48-.529.413-.476.484-.503.872-.08.904-.357.686-.128 1.283.579.402.6.84 1.011.78-2.368 2.49-.862 1.267-.578.785-.749.633-.632.466-.785.468-.602.316.967 1.396-.133.577-.985.748-1.066.731-1.054.71-.995.734-1.379.745-1.18.424-1.22.434-1.16.406-1.389.383-2.008.473-1.498.231-1.455.16-1.428.252-2.448.256-3.183.249-2.827.049-3.45-.077-2.468-.168-2.3-.318-2.75-.497-2.53-1.087-2.41-1.243-1.706-1.606-1.696-2.104-1.21-1.445-.822-2.02-.847-3.236-.754-2.459L88 158.772l-1.448-2.192-1.866-2.711-.813-3.915-2.06-3.991.752 1.502.857 1.65 1.683 3.062 1.834 2.575 1.812 2.204 2.254 2.257 2.447 1.958 3.474 2.106 3.354 1.281 2.92.883 3.8.663 3.36.142 3.667-.23 3.363-.681 3.486-.91 2.907-1.017 3.986-1.898 2.473-1.576 2.697-2.09 2.029-2.035 1.279-1.87 2.311-3.666.443-.53.59-.207.705.004.03-.71-.343-.053-.093-.197.28-.307.354-.325.318.517 1.116-.22.749.085-.126-.597z",
    display: "inline",
    opacity: 1
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M140.384 149.673c-.06.915 1.165 1.27.243 3.668-1.2 3.119-2.145 6.563-3.297 10.15-.066.205.114.512-.047.771-.16.256-.503.475-.62.772-.021.16.07.339-.133.468l-1.918.746c.147.766.313 1.524.758 2.158l.852.094 2.063-1.283-1.258 2.482-1.948 1.453-1.433.696-.637-.288.029-.52 1.765-1.256-7.045 3.012-.89 1.232-13.92 2.805c-3.878.487-7.057-.074-10.28-.567-3.172-.703-5.705-2.042-7.866-3.755-1.37-1.745-3.234-3.194-3.848-5.392l-1.11-4.057-1.291-3.236c-1.01-1.79-.95-2.136-1.777-3.434-1.449-2.274-2.628-4.888-3.467-7.13-.453-1.209-.68-1.21-1.519-3.428.812 1.877 4.27 9.511 8.049 13.888 8.838 10.235 38.755 11.06 40.2 9.124l.163-.555s.54-.022 1.005-.166l.103-.91 5.305-2.383 3.711-11.535c.523-1.431.26-2.515.058-3.624z",
    display: "inline",
    opacity: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.827,
    cy: -139.538,
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    display: "inline",
    opacity: 1,
    rx: 0.67,
    ry: 0.364,
    transform: "rotate(90)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M154.793 133.628l-.673-.31s-3.31-1.095-3.307-1.082c.002.011 3.318 1.13 3.317 1.134l.638.278s-1.338 3.367-1.553 5.053c-.122.952.125 1.98.149 2.94.015.65-.175 1.795-.319 2.407.07-.639.205-1.8.235-2.436.044-.969-.162-1.976-.04-2.938.218-1.703 1.553-5.046 1.553-5.046zm-.789-.28c-.217.533-1.99 4.74-2.24 5.102-.86 1.243-2.642 1.64-3.54 2.857-.801 1.085-1.45 2.195-1.58 3.538-.13 1.368-.225 3.75.896 4.546.636.453 1.66.034 2.342-.347 1.079-.603 1.932-1.824 2.531-2.947-.6 1.098-1.46 2.283-2.523 2.872-.676.374-1.69.793-2.32.345-1.108-.79-1.015-3.152-.885-4.507.127-1.329.788-2.387 1.58-3.461.89-1.205 2.636-1.636 3.488-2.867.255-.369 2.032-4.587 2.251-5.131z",
    display: "inline",
    opacity: 1
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M150.287 132.368l-2.34 4.76s-1.76.93-2.301 1.72c-1.591 2.322-2.46 8.135-2.267 8.135-.224.396 3.326 2.494 3.575 2.338-.264.232-3.973-1.732-3.698-2.362-.2.025.667-5.76 2.22-8.082.562-.84 2.395-1.858 2.395-1.858z",
    display: "inline",
    opacity: 1
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M109.566 88.066c-4.938 1.753-9.66 3.821-13.098 7.905 4.316-3.893 8.698-6.101 13.098-7.905z",
    display: "inline",
    opacity: 1
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.461,
    d: "M151.04 102.439c-1.628-.766-3.898-1.61-5.752-1.85 2.121.151 3.63.14 5.752 1.85z",
    display: "inline"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.461,
    d: "M158.347 122.382c1.054 5.342.96 10.22-.18 12.753.587-3.802.95-7.245.18-12.753z",
    display: "inline"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.461,
    d: "M136.51 165.616l-1.687.75c.222.822.386 1.471.703 1.96 1.289-.87 2.148-.827 3.86-2.753.184-.596.128-1.116.173-1.619-.034-.744-.038-1.177-.529-1.466-.354-.343-.816-.414-1.17-.51.483.334 1.147.218 1.502 1.194.092.8.068 1.621-.096 2.36-1.545 1.855-2.526 1.93-3.711 2.687-.296-.52-.474-1.14-.604-1.802z",
    display: "inline"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    fillOpacity: 1,
    stroke: "#000",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M91.68 96.83l-8.883 18.177-.188.666-.103.628-.366 1.529-.338.858-.341.28-.026.696-.396.64-.97.636.178.538-.496 1.287-.029.99.453 1.388.543 2.192.155 3.607-.141 3.936-.308 4.21.257 1.964.12.931.413 1.298.303 1.047.16.788.557 1.263 1.105 2.272 1.959 3.616 1.774 2.546 1.808 2.286 2.206 2.304 2.52 1.95 3.164 1.86 3.479 1.411 3.171.92 3.546.62 3.435.12 3.93-.356 4.053-.716 5.6-1.76 4.118-1.99 4.984-3.586 2.017-2.108 3.505-5.53.375-.487.65-.207.658-.014.04-.69-.356-.055-.088-.194.646-.64.332.525 1.088-.227.722.076-.081-.645.203-.973.445-.377.368-2.36.193-.817 1.176-2.873.536-2.25.016-1.2-.327-2.142-.138-.536-.114-.424-.397-.817-1.65-3.065-.292-.617-.363-.27-.066-.752-4.464-7.476-.583-1.623-.86-1.122-2.922-3.454-2.857-3.044-3.681-2.638-3.925-3.079-5.664-3.983-5.67-2.66-2.526-.978-2.582-.76-2.908-.706-4.28-.294-3.558.22-1.36-.157-1.674-.033z",
    display: "inline",
    opacity: 1
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M82.28 117.25l1.257-1.148 1.083-1.115.596-.685.528-.652.617-.801.757-1.168.721-1.339.63-.942.823-.441.257.003-.207 1.03-.733 1.455-1.221 1.687-.899 1.023-.752.612-.384 1.25-.798 2.172-.425 1.01 1.547-4.518 1.705-1.567.91-1.354.785-1.378.159-.408.164-.809-.173-.016-.749.306-1.942 3.436-.86.976-.684.888-1.036 1.125z",
    display: "inline"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M84.198 115.64l.082 1.024-.528-.325.4.383.407.114.305.034-.739 2.257-.213-.012.154-.595-.064-.178-.346-.073-.278.19.216-.378.667-1.02-.627-.539.042-.377.462.332z",
    display: "inline"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M91.13 142.711l.18 1.615-.4 1.292-.62.439.325.76.018 1.576-.497.486-.385-.663-.146-1.217-.657-.613.073.92 1.027 1.66.718.053.905.618-.1-1.13.66 1.077.178 1.029 1.049-.153-.996.72.315.837.69.627 1.208.662-1.414.806.455.792-1.054.362.381.822.709-.992.68.21.617 1.756.294.885.838.302.198-.906.501-.516-.505 1.203.005 1.006.44.47-.002-1.137.852-1.033-.628 1.218.043 1.19.35-.422.119-.478.348-.507-.193.713-.274.906.297.306.352-.765.66-.533-.663.838-.203.787.405.046.262-.575.54-.501.032.382-.568.434.084.663.405.013.738-.522.648-.167-.858.839 1.39-.395 3.328 2.256-2.372 1.808-4.808-1.302-3.299-1.87-2.682-2.276-4.11-4.476-2.595-3.914-2.258-4.274-1.183-3.871-.542-2.005.091-3.774.171-3.512.003-4.542-.115-1.924-.895-3.015-.08-1.19.675-1.477.619-.838.717-1.576.896-.84-.092 1.878.679.733 1.087-1.078 1.668-1.9 1.038-3.22-.268 2.665 1.44-1.306-2.427 4.617.016.92 1.153-1.083.21 1.225-.343 1.624 1.186-.88.09-.385.776.521.25.853-.633 1.026-.83.518-.337 2.012-.163 2.004.309 1.613.967-.125-.28 1.545-.02.66-.356 2.894.124 1.826.785.65 1.143.931.015-1.783.727.126.805-2.865-.134 4.572.413.544.727.78 1.035.521-.086 1.1-1.123-.362-.049.58 1.012.696-.25 1.335-.923-1.227-.759-.81z",
    display: "inline"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M107.716 161.68l-.476-.14-.239.405v.209l.581.139-.09-.198.03-.202z",
    display: "inline"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M102.694 155.176l1.124 1.134 2.147 1.788 1.338 1.067.647.404.2-.058-.406.11-1.844-1.476-2.088-1.697z",
    display: "inline"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M107.596 155.762l-.289-.193-1.71 1.567-.564-.033.447.373 1.957-1.679z",
    display: "inline"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M108.353 156.859l-.51-.26-.353.279.53.478z",
    display: "inline"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M106.81 157.04l.567.5-.768.841-.494-.445.02-.29z",
    display: "inline"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M109.37 156.735c-.798.705-1.615 1.42-2.198 2.026.74-.486 1.47-1.241 2.198-2.026z",
    display: "inline"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M109.35 156.886l-1.34-.724-.276-.422-1.656-1.578 1.795 1.514.096.516z",
    display: "inline"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M108.402 154.924c.42.628.721 1.258.979 1.888-.375-.62-.68-1.254-.979-1.888z",
    display: "inline"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M106.946 154.57l.511.422.4.04c.304-.09.334-.214.418-.429l-.587-.013-.288-.254c-.093-.088-.135-.124-.187-.203l-.056-.464-.004-.275-.635.74z",
    display: "inline"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M106.633 154.044l-.586.057c.166-.066.378-.058.586-.057z",
    display: "inline"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M105.785 154.128l-1.967 1.629-1.318-.903-1.02.988.143.827-1.343.37-1.093-.536-1.79-1.042-1.403-1.798 2.141.633.859-1.91.069 1.597.802-.136.444-2.292 1.363 1.809 2.018.81.938-.049z",
    display: "inline"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M91.541 142.542l1.338 2.526.834 3.014 1.396 3.802.289 1.516-.538-2.375-.76-2.565-.931-3.203z",
    display: "inline"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M95.691 153.824l1.322 1.62 2.444 1.845 1.042.338 1.343-.701-1.633.54-2.54-1.518z",
    display: "inline"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M106.782 160.35l.186.478 4.415 2.194 1.704.453.645.919.274 1.435-.165-1.292-.601-1.014-1.973-.376-4.379-2.222z",
    display: "inline"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M95.829 154.87l.597.295-.275.133z",
    display: "inline"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M96.837 155.764l-.29.156-.186-.38z",
    display: "inline"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M96.957 156.432l.354-.154-.345-.35-.264.146z",
    display: "inline"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M97.545 157.085l.41.278.097.17.213.207-.025.17.138.208.272-.106-.12-.308-.174-.08-.177-.377-.184-.257z",
    display: "inline"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M98.818 158.363l.447.537.439.49.266.384.53-.44.04-.138-.476-.077-.312-.195-.339-.456-.139-.213z",
    display: "inline"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M100.969 160.038l.845.709 1.183.806 1.207.836 1.103.684-.208.338-.029.69.493.047.575-.287.25-.33.626.331 1.021.463 1.288.489.639.267.567.958 1.805.2 1.514-.225-.513-1.313-.393-.86-1.132-.171-.973-.438.878.601-.96-.145-.349-.006-.273-.241-.325-.29-.073-.466-.342.223.218.378.678.526-1.15-.129-.823-.035-.396-.672-.805.293-.427-.4-.175-.428.246-.787.12-.36-.223-.075-.286.337-.042.431.025.627-.366-.288-.276-.452-.682.138-.086-.89.01-1.14-.502-.546-.525-.387-.724-.258.14.665.19.434.357.497-.098.578-.416-.303-.362-.845.196.868-.463-.37-.66-.3-.742-.107-.371-.132-.226.225z",
    display: "inline"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M106.402 159.604l-1.415-1.189-1.883-1.574-.15-.25.267-.27-.477-.545-.443-.36-.763.51.416.588-.056.368.463.45 1.216 1.222.975.562.532.273z",
    display: "inline"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M107.167 153.386l.145-.298.226.007.154.13.158.178-.072.216-.205.318.136.127.258.097.13.176.136.21-.087-.307-.146-.14-.178-.212.228-.372-.167-.34-.312-.2-.358.111z",
    display: "inline"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M115.138 114.578l-2.42 3.964-2.391 5.085-2.964 7.024-2.975 7.31-2.733 7.541-1.459 5.127-.368 2.961.531-2.898 1.429-5.103 2.752-7.597 2.907-7.29 2.981-7.037 2.367-5.045z",
    display: "inline"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M114.609 114.067l-2.583 4.182-2.549 4.884-2.994 7.26-2.975 7.31-2.555 7.335-1.493 5.45-.253 3.18.416-3.116 1.463-5.427 2.573-7.391 2.907-7.29 3.013-7.272 2.524-4.844z",
    display: "inline"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M101.694 146.06l-.585.057c.165-.066.378-.058.585-.057z",
    display: "inline"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M108.095 110.27l-2.877 3.318-4.354 4.693-4.965 6.877-4.243 7.905-1.447 3.924.163.064 1.418-3.9 4.261-7.961 4.896-6.858 4.372-4.706 2.853-3.278z",
    display: "inline"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.384,
    d: "M107.403 109.977l-3.035 3.117-4.385 4.929-4.964 6.877-4.064 7.7-1.483 4.247.163.063 1.453-4.223 4.082-7.755 4.897-6.858 4.403-4.941 3.01-3.078z",
    display: "inline"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M108.11 110.72c2.067 1.297 4.215 2.659 6.068 4z",
    display: "inline"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M107.775 110.925c1.962 1.414 4.077 2.888 6.126 4.163z",
    display: "inline"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M105.562 113.735c2.211 1.346 4.405 2.71 6.508 4.167-2.237-1.357-4.364-2.766-6.508-4.167z",
    display: "inline"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M105.192 114.174c2.14 1.44 4.275 2.849 6.39 4.147z",
    display: "inline"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M101.205 118.289c2.924 1.474 5.805 3.073 8.662 4.745z",
    display: "inline"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M100.825 118.764c2.75 1.617 5.56 3.211 8.518 4.745z",
    display: "inline"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M96.422 124.988c3.423 1.65 6.85 3.288 10.197 5.132z",
    display: "inline"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M96.05 125.341c3.375 1.82 6.748 3.644 10.26 5.32z",
    display: "inline"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M92.063 132.885c3.814 1.734 7.643 3.363 11.527 4.625z",
    display: "inline"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M91.61 133.52c3.709 1.842 7.607 3.473 11.779 4.516-4.071-1.246-7.932-2.868-11.778-4.516z",
    display: "inline"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M92.28 141.701c2.853 1.363 5.798 2.408 8.813 3.207z",
    display: "inline"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M92.161 142.367c2.917 1.336 5.846 2.36 8.782 3.223z",
    display: "inline"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M94.22 148.48c2.13 1.008 3.829 1.384 5.486 1.7z",
    display: "inline"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M94.392 149.442c1.623.617 3.336 1.057 5.093 1.41z",
    display: "inline"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M90.319 103.643l1.797 2.158-7.56 13.453 7.834-13.414z",
    display: "inline"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M89.946 103.821c-5.718 7.19-6.776 10.548-7.435 13.148.855-3.089 4.039-8.146 7.435-13.148z",
    display: "inline"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M85.201 110.582l4.9-6.798 2.18 1.924-1.219 2.665-.448 1.402.932-.517-.567 1.74.74.152-.225.3 1.13.143-.328 1.186 1.052-.69-.088 1.09.481.254.68-.165 1.144-1.666.795.407-.042.54.134.237 1.463-1.374 1.822-1.259.933.302-.918 1.696-.018.247.468-.11.134.252-.203.826.72.01.396-.995.664-.488.932-.28.561-.835.6.565-.893 1.658-1.152.671.335.349.549.259.963-1.187 1.039-1.153 1.095-1.564 1.368-.877.993-.36.75 1.233 1.432-.738 1.817-1.769.955-.682 1.026-.09.436.318.985-.334.134-.475-3.43-2.054-4.558 2.354-3.097-2.788 2.19-2.249 2.22-1.31 1.45-1.619-2.121-1.033-3.925-.972-4.356-.67-3.636.32-2.25-.105-1.575.087-1.19.25z",
    display: "inline"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M95.747 150.077c.017.932.001 1.862-.117 2.788z",
    display: "inline"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M95.67 153.498l1.679.463c-.919-.457-1.144-.33-1.68-.463z",
    display: "inline"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M95.314 152.932l2.182.484c-.728-.318-1.455-.401-2.182-.484z",
    display: "inline"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M96.754 144.391c-.29 1.266-.596 2.359-.797 4.566z",
    display: "inline"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M93.04 142.869c-.091.567-.202 1.113-.212 1.776z",
    display: "inline"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M99.514 137.066l-2.317 6.377c.657-2.12 1.347-4.24 2.317-6.377z",
    display: "inline"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M94.89 135.347c-.731 1.994-1.393 4.068-1.81 6.421z",
    display: "inline"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M103.197 129.286c-1.151 2.093-2.207 4.38-3.201 6.795z",
    display: "inline"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M99.908 127.56c-1.62 2.188-3.041 4.357-4.428 6.523z",
    display: "inline"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M106.78 122.514c-1.176 1.948-2.12 3.937-2.99 5.94z",
    display: "inline"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M103.957 120.896c-1.369 1.964-2.535 3.887-3.358 5.737z",
    display: "inline"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M109.802 117.44a29.123 29.123 0 00-2.44 3.96z",
    display: "inline"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M107.327 115.969c-.863 1.147-1.725 2.329-2.597 3.944z",
    display: "inline"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M113.654 101.205l-1.909 2.23 4.196 2.92 4.489 4.065 1.242-1.737-1.223 1.929-4.479-4.118-4.369-3.128z",
    display: "inline"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M120.998 106.64l-1.259 2.003-3.346-2.347-2.919-2.164 1.6-1.844-1.69 1.92 6.409 4.55z",
    display: "inline"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M116.088 103.232l-1.232 1.3 3.912 3.056.852-1.24-.833 1.38-4.012-3.102z",
    display: "inline"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M109.554 112.447l-1.792 2.404c.392-.842 1.081-1.605 1.792-2.404z",
    display: "inline"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M111.814 114.005c-.61.72-1.078 1.65-1.482 2.497z",
    display: "inline"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M110.113 111.636c1.491-1.514 3.03-2.956 4.744-4.134z",
    display: "inline"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M112.405 113.214a44.112 44.112 0 012.741-5.324z",
    display: "inline"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M119.983 111.993c-3.916 6.042-7.806 12.093-11.167 18.312z",
    display: "inline"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M108.183 130.566c.727 1.362 1.54 2.658 2.523 3.828z",
    display: "inline"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M107.557 130.644l1.378 2.126c-.535-.63-1.032-1.299-1.378-2.126z",
    display: "inline"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M108.583 132.57c-.803-.41-1.038-.734-1.462-1.087z",
    display: "inline"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M103.165 129.777c.669.844 1.386 1.676 2.44 2.417z",
    display: "inline"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M106.601 132.803c.663.52 1.382 1.013 2.454 1.34z",
    display: "inline"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M110.73 135.005c-2.832 2.939-5.705 5.801-8.377 9.042z",
    display: "inline"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M109.26 134.375c-1.754 1.668-2.916 2.548-5.72 5.99z",
    display: "inline"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M102.168 141.063a27.037 27.037 0 00-2.59 3.45z",
    display: "inline"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M100.586 145.692c-1.19 1.306-2.335 2.71-3.626 3.8z",
    display: "inline"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M99.284 145.22c-1.158.867-2.308 1.744-3.178 2.912z",
    display: "inline"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M111.334 129.012l-.597 8.843c.033-3.365.254-6.343.597-8.843z",
    display: "inline"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M110.41 128.742c-.312 1.485-.579 3.104-.495 4.59z",
    display: "inline"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M109.997 135.926c-.13.659-.29.664-.057 2.18z",
    display: "inline"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M111.356 128.91c-.24-.602-.506-.995-.938-.112.288-.452.587-.67.938.112z",
    display: "inline"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M112.342 126.833c-.179 3.884-.146 7.78-.054 11.679z",
    display: "inline"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M112.097 126.803c-.106.065-1.218.667-1.115.84z",
    display: "inline"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M112.398 138.462c.514-.708 1.548-1.574 2.34-2.366-.964.852-2.353 1.85-2.34 2.366z",
    display: "inline"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M110.837 137.583c.404.327.839.624 1.338.858z",
    display: "inline"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M114.818 130.77l.027 5.198a35.207 35.207 0 01-.027-5.198z",
    display: "inline"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M114.637 126.75c-.741-.06-1.483-.11-2.238-.013z",
    display: "inline"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M114.608 126.764l-.055.46 1.173-.502.034 1.257-1.255.384-.004.229 1.236-.268.09.988-1.06.397.015.202.007-.148 1.124-.415-.09-1.02-1.213.162-.007-.057 1.24-.432-.004-1.311-1.244.427z",
    display: "inline"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M114.315 129.687c-.12.051-.422.016-.422.016l.137.834 1.016.067.582.037-.993-.17-.252.036z",
    display: "inline"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M113.548 129.696l.133.791-.222.361.033.278.192.509-.606.47-.059 1.294.933.033-.264.494-.85.004-.038-2.159.483-.237-.226-.764.197-.271-.018-.493z",
    display: "inline"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M112.816 135.61l-.02 1.513-.223-.443z",
    display: "inline"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M113.838 136.068l-.453-.212-.017.391z",
    display: "inline"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M114.318 131.9l.283.27.004 1.581-.07.669-.443-1.015.192-.179.098-.882z",
    display: "inline"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M114.893 130.015l.72.106.257-.31.436-.136.168.135.352-.618.185-.63.62-.212.243-.125-.409-.403-.19-.743-.399.145v.5l-.693.017-.278.121-.403.328.495.193.094.865z",
    display: "inline"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M114.322 126.54l.462-.745.052.261.39-.035.096-.411.302-.162.447-.174.936.573-.327.747-.216.067.259.316-.147.503-.491.077-.026-.732-.263-.103-1.058.323-.038-.325z",
    display: "inline"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M116.55 129.836c.27.165.24.368.246.567z",
    display: "inline"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M116.825 130.612s-.121.284-.242.365c-.14.094-.336.154-.494.099-.19-.066-.389-.457-.389-.457s.136.405.31.492a.66.66 0 00.65-.051c.127-.096.165-.448.165-.448z",
    display: "inline"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M115.764 119.559l1.664 1.312.46-1.017-1.433-1.133-.452.676.498-.845 1.557 1.3-.624 1.185z",
    display: "inline"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M117.34 121.212c.239.03-2.36 4.365-2.506 4.415z",
    display: "inline"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M119.523 115.332c.423 1.075.577 2.126.729 3.176z",
    display: "inline"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M120.919 119.304c-1.417 2.15-2.867 4.28-4.524 6.276z",
    display: "inline"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M118.72 122.634c.663-.252 1.319-.474 1.93-.518z",
    display: "inline"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M120.73 122.506c-.804 3.909-1.975 7.669-3.05 11.467z",
    display: "inline"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M119.444 123.941c-.543 3.041-1.422 5.587-2.214 8.26z",
    display: "inline"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M119.22 123.957c.016.13-1.795 2.19-1.843 2.104z",
    display: "inline"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M118.564 123.75c-.566.585-1.15 1.17-1.508 1.773z",
    display: "inline"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M116.227 131.31c.358.246.722.469 1 1.055z",
    display: "inline"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M115.503 131.413c.458.64.927 1.248 1.481 1.621z",
    display: "inline"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M115.341 131.386c-.155.034-.345.204-.444.015z",
    display: "inline"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M116.913 133.15c-.157 1.241-.236 1.912-.338 2.757.194-.898.32-1.755.338-2.758z",
    display: "inline"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M117.843 133.485c-.243.841-.426 1.703-.938 2.455z",
    display: "inline"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M118.532 114.76c1.435.517 2.759 1.362 4.08 2.216z",
    display: "inline"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M118.798 114.025c.934.983 2.304 1.615 3.677 2.244z",
    display: "inline"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M119.877 112.756l2.677 3.59c-.788-1.259-1.555-2.531-2.677-3.59z",
    display: "inline"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M120.433 112.4c.829 1.45 1.702 2.79 2.672 3.904z",
    display: "inline"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M119.57 109.813l-1.019.16.95 1.596-.128.265-3.91-.09-.131-1.155 2.45.213-.36-.866-1.42.106.216-.966-.552-.663 1.412-.63z",
    display: "inline"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M120.342 127.795l1.957 2.18 2.131 1.064 2.48.019 2.587 2.61 1.64 1.64 2.112.65.979.972 1.682 1.15.028-2.291 2.222 1.443.764 1.25 1.936-.073-1.097 3.313.42 1.183.643 2.583 1.74 1.797.83-1.916.154-1.349.883-2.593.886-2.629.116-3.124-.809-2.64-2.073-3.775-2.35-4.049-1.643-3.377-1.208-1.923-1.014-2.06-2.396-2.738-4.124-4.073-2.828-1.98-1.647 2.837-3.186.62-.292 1.205 1.547 2.928-.436.612-2.325-.551-.275 1.173 1.008.234-.246 1.77-.873 1.154.715.945.145.592-.742 2.22-.714 2.588z",
    display: "inline"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M120.553 110.807c1.478 1.542 3.057-.756 4.593-1.405-1.529.697-3.034 3.566-4.593 1.405z",
    display: "inline"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M124.389 109.373c-1.234.47-2.61 2.07-3.643.94 1.027.699 2.416-.557 3.643-.94z",
    display: "inline"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M100.234 116.109c-.454-.003-.73-.241-1.068-.4z",
    display: "inline"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M99.843 117.054c-.265-.081-.482-.073-.957-.555z",
    display: "inline"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M99.52 117.664l-.8-.55c.235.264.51.43.8.55z",
    display: "inline"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M98.45 117.65c.206.323.464.583.83.713z",
    display: "inline"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M98.996 118.981c-.375-.206-.648-.472-.928-.733z",
    display: "inline"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M97.79 118.768c.245.318.516.613.79.905z",
    display: "inline"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M102.541 130.636l1.2.603.21-.008.014.283 1.32 1.94.39-.908-.568-.603-2.094-2.165z",
    display: "inline"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M106.347 133.463l1.649 2.103-.408.446-1.323-1.638-.32-.002z",
    display: "inline"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M109.29 136.704l.608.807s.15.52.037.74c-.065.127-.356.232-.356.232l-.94-1.21z",
    display: "inline"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M110.968 137.747s.383.211.56.337c.216.153.499.268.61.507.104.23.126.546-.012.757a.512.512 0 01-.463.208c-.279-.036-.487-.306-.656-.532a.984.984 0 01-.201-.48c-.027-.27.162-.797.162-.797z",
    display: "inline"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M102.205 112.072c-.318.437-.662.449-.937 1.62z",
    display: "inline"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M99.161 111.49l-.469 1.002.185.3.845-.294-1.228 2.464.494.276.188.262-.796 1.715-.31-.059-.762 1.064.386.398-.513-.194-.472.765.27.344-.237.411-.717.365-.088.484.4-.023-.34.917-.154.96.168.723-.609.97-.69 1.048-.86.228-3.423-.595.09-.43 2.106.112-.553-1.08.228-1.137.618-1.294.65-1.429.789.01.187-.428.208.257-.003.296.35.191.384-.253.05-.53-.517-.14-.388.38-.165-.05.05-.36-.404-.087.755-1.628-.746-.65.87.346-.76-.704.89.337-.698-.58.893.304-.472-.44.541.225.125-.47-.423-.203.54.156.549-.798-.247-.212-.303.132-.254.02-.251-.138-.262.048-.405.009.117-.88.545.117.397.144.664.491.234-.433-.622-.536.153-.19.503.546.914-.728.82-1.011.728-.682z",
    display: "inline"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M94.185 117.457l-.515 1.392.35.121-.755-.21.27-.032z",
    display: "inline"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M93.614 119.534l-.22-.128-.703-.074.505.3-.923 1.136-.365.938.051.373.267-.048.062-.692.188-.188.24-.42.487-.992z",
    display: "inline"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M93.505 114.088l-.756 1.916-.767 1.803-1.11 1.767-.98 1.952-.503.516.556-1.045.472-.832-.077-.731.862-.885.406-.716.482-1.322.536-1.134z",
    display: "inline"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M92.673 113.067l-.444 1.164.014.677-.474 1.203-.47 1.27-.8.405-.33.456.258.274-.691.268.227.736.116.444-.259.212-.545-.381-.354.625.208.423.158.618-1.013-.05.15-.69.511-.933-.2-.433-.631.484-.558-.253-.165-.263.654-1.3-.984.233-1.302 2.536-1.428-1.371.88-1.186 1.45-2.556.382-.549.318.366-.837 1.56.514.092.952-1.53.104.759.47.203.588-1.424.323-.665-.177-.244.743-.855.51-.114.663-1.032-.528 1.27.048.387.664-.37-.68 1.128.082.793.531.034.252-.191.357-.262-.095-.654.301-.775.347-.703z",
    display: "inline"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M91.084 121.37l-1.462 2.1-1.736 3.234-.351.97.495.08.569-1.618.489.033-.495 1.562-1.249-.017-.153.74.773.245-.282.989-.54-.118-.644 4.255 1.444-.189.618-3.224 1.614-3.842.625-1.33-.049-.443-1.49.467.527-1.417.328.431-.27.86.871-.226-.452-.155.406-1.012.485-.85.706-.424-.583-.25-.125-.258z",
    display: "inline"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M92.45 126.995l-.29.855-.342.469-.675.495-.294-.326-.413 1.795-.365.743-1.596 1.453-1.289.453-.357 2.085 1.286-.302 1.066-.968.476-.383-.075 2.74.847-1.796.744-1.914.69-1.367.23-1.043.25-1.475z",
    display: "inline"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M139.052 147.489l-2.095-1.943-1.15-.362-.468-1.424-1.087-1.011-.358-1.057-1.188-1.267-1.827-1.08-1.298.244-2.476-.105-1.339-.968-1.45.207-.744.917.608.922-1.241-.812.815 1.158-1.306-.73.667 1.344-1.196-.44-.492.275.373 1.364-1.263.447-.416.74.61 1.333 1.125 1.168 1.138 1.792 1.322.89 1.185.148 1.707-.954.15-1.336 1.177-.969 1.226-.58-.227-1.485-.134-1.093.88-.817.388-1.489-.19-.754 1.02.154 1.065.845.908.612.442 1.29 1.12 1.242.206.77.27.467 1.213.792.797.525z",
    display: "inline"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M131.84 137.119l-1.72-1.13-1.706-.953-1.076.802.065 1.147.689 1.204 1.18.194.5-.314.252.664.578.099.749.085.445-1.605z",
    display: "inline"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M132.024 137.21l.232-.09.185.29.079.188.002.423-.3.698-.322.63-.341-.084-.032-.43.192-.645.174-.709-.313 1.35.025.387.287.014.54-1.122.047-.434-.21-.42z",
    display: "inline"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M128.944 150.397l-.422-.615-.32.083-.964.383s-.026.524-.111.536c-.086.012-.415.256-.415.256l.155.303.413.205.29.7.245.809.635.073.029-.94-.021-.857z",
    display: "inline"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M128.664 149.7l.42-.357.5-.026.373.47-.022.807-.365.288-.03.93-.16.45-.005.505-.514.248-.318.026.863-.196.076-.463.132-1.413.366-.338.02-.8-.381-.598-.633.049z",
    display: "inline"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M133.42 146.464c-.162.487-.794 1.32-.794 1.32l-.952 1.394 1.085-.588.075 1.046.837-1.096.386.09-.255-.871z",
    display: "inline"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M110.432 147.488l-.96-1.27-.465-.277-.525.128-.89.501-.042.77s.355.765.326.669c-.03-.097.634.578.634.578l.921.089.906-.121.146-1.07-.084 1.132-1.014.246-.97-.136-.954-1.14-.014-1.085.98-.546.66-.177.435.353 1.037 1.341z",
    display: "inline"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M124.652 158.52l-.961-1.27c-.188-.07-.327-.282-.546-.255-.23.055-.471.091-.667.233l-.666.375-.042.77c.108.225.207.456.327.677.175.069.277.241.418.358.113.13.267.267.454.234.254.017.507.07.762.055l.826-.11.146-1.07-.084 1.133-1.014.246-.97-.136-.954-1.14-.014-1.085c.33-.183.657-.37.989-.55l.65-.173c.204.174.439.319.587.549l.886 1.145-.127.015z",
    display: "inline"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 1.384,
    d: "M119.865 149.15l-2.567-.977-1.226.696.578 1.93.275.563 2.179.663 2.074-1.393-1.04-1.447-2.757-.863 2.616.912.97 1.313-1.907 1.242-1.267-.324-.968-.698-.528-1.942 1.067-.485z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M166.21 40.022l-1.485 1.85-.003 1.434-.286 1.04-.882-.012-.02-.641.568-.47-.244-.536-.627.217-.6.96.463.95 1.798.22.581-1.96.39-1.585 1.49-1.019z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.384,
    d: "M178.665 41.992l-1.616.433-.205-1.405-1.036.006s-.864-.512-.934-.494c-.069.018-.626.882-.66 1.029-.035.146-.787 1.196-.787 1.196l.273.79 1.214.313.338.964-.366 1.183.802.426.943-1.267 1.003.543.1-1.399.866.456.283.764.05-.646.103-.429-.324-.646.04-.98.29-.497z"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "Major Tom",
    transform: "matrix(.45306 .0296 0 .46234 81.69 70.6)",
    style: {
      lineheight: 1.25
    },
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.755,
    fontFamily: "Verdana Pro",
    fontSize: 12.66,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    letterSpacing: 0,
    wordSpacing: 0
  }, _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M72.677 52.736l-1.188-.296 1.922-7.695-3.79 4.616-.708-.177-1.158-5.851-1.921 7.695-1.11-.278 2.23-8.93 1.62.405 1.139 5.566 3.544-4.397 1.65.412z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M79.871 55.676l-1.067-.443.282-.68q-1.006.246-1.573.177-.57-.062-1.072-.27-.868-.36-1.23-1.18-.355-.823.01-1.703.478-1.153 1.57-1.349 1.1-.2 3.761.791l.069-.165q.251-.606-.003-1.059-.25-.459-1.21-.857-.874-.362-2.195-.402l-.058-.024.453-1.09q1.28.19 2.199.57 1.479.614 1.894 1.436.423.818-.034 1.92zm-.416-2.013l.737-1.776q-2.17-.787-2.874-.67-.698.118-.959.746-.457 1.102.885 1.658.942.391 2.211.042z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M87.497 50.527l-1.164-.603.554-1.07 1.164.602zm-3.85 7.272q-.556 1.076-1.39 1.34-.833.265-1.755-.212-.637-.33-1.1-.765l.508-.983.055.029.276.275q.289.289.536.416.587.305 1.037.175.447-.123 1.046-1.281l2.558-4.94-1.279-.663.45-.867 2.31 1.196z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M87.93 60.308q-1.241-.768-1.466-2.049-.226-1.28.669-2.726.891-1.44 2.136-1.819 1.25-.375 2.495.396 1.23.761 1.449 2.052.227 1.29-.66 2.725-.889 1.435-2.139 1.81-1.25.375-2.485-.39zm3.307-5.346q-1.692-1.048-3.084 1.202-.687 1.11-.597 1.95.096.844.9 1.342.789.488 1.584.202.803-.288 1.492-1.402 1.393-2.25-.295-3.294z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M99.003 60.875l-.05-.036-.228-.243q-.261-.26-.576-.49-.768-.562-2.12-.493l-2.892 3.957-.939-.685 4.075-5.575.938.686-.602.823q1.61-.086 2.458.534.325.237.64.56z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M110.196 66.904l-2.548-2.079-5.13 6.289-.95-.774 5.132-6.288-2.548-2.08.688-.842 6.044 4.932z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M107.187 75.133q-1.12-.933-1.165-2.233-.044-1.3 1.044-2.606 1.084-1.301 2.37-1.502 1.29-.197 2.415.741 1.112.926 1.148 2.235.044 1.308-1.036 2.605-1.08 1.296-2.37 1.493-1.29.197-2.406-.733zm4.023-4.83q-1.53-1.274-3.222.759-.835 1.002-.863 1.847-.024.85.703 1.455.713.593 1.54.421.835-.173 1.674-1.18 1.693-2.033.168-3.303z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M118.381 85.194l-.827-.816 2.763-2.798q.951-.963.966-1.444.019-.476-.505-.993-.593-.586-1.997-.757-.213.277-.465.532l-3.106 3.144-.827-.816 2.763-2.797q.943-.955.97-1.431.028-.477-.508-1.007-.585-.578-1.946-.749l-3.623 3.668-.826-.816 4.852-4.913.826.817-.538.545q1.496.13 2.265.891.994.982.586 2.151 1.728.134 2.585.98 1.579 1.56-.258 3.42z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.5c55ca6f7fd80162c36014ae6ffa9e9a.svg";
export { ForwardRef as ReactComponent };